import { getOrgDetails } from "../utils/orgUtil";

const ENV = import.meta.env.VITE_APP_ENV || "local";
const getApiUrls = () => {
  const orgDetails = getOrgDetails();
  const isParent = orgDetails?.isParent == true;

  switch (ENV) {
    case "production":
      return {
        MAIN_API_URL: import.meta.env.VITE_MASTER_API_URL_PRODUCTION,
        WORKFORCE_API_URL: import.meta.env.VITE_WORKFORCE_API_URL_PRODUCTION,
        WORKFORCE_SOCKET_API_URL: import.meta.env
          .VITE_WORKFORCE_SOCKET_API_URL_PRODUCTION,
        ATS_API_URL: import.meta.env.VITE_ATS_API_URL_PRODUCTION,
        ATS_SOCKET_API_URL: import.meta.env.VITE_ATS_SOCKET_API_URL_PRODUCTION,
        BENCHSALES_API_URL: import.meta.env.VITE_BENCHSALES_API_URL_PRODUCTION,
        NONITMARKETING_API_URL: import.meta.env
          .VITE_NONITMARKETING_API_URL_PRODUCTION,
        MIXPANEL_TOKEN_ID: import.meta.env.VITE_ATS_MIXPANEL_TOKEN_PRODUCTION,
        ADMIN_API_URL: import.meta.env.VITE_ADMIN_API_URL_PRODUCTION,
      };
    case "staging":
      return {
        MAIN_API_URL: import.meta.env.VITE_MASTER_API_URL_STAGING,
        WORKFORCE_API_URL: import.meta.env.VITE_WORKFORCE_API_URL_STAGING,
        WORKFORCE_SOCKET_API_URL: import.meta.env
          .VITE_WORKFORCE_SOCKET_API_URL_STAGING,
        ATS_SOCKET_API_URL: isParent
          ? import.meta.env.VITE_ATS_SOCKET_API_URL_STAGING
          : import.meta.env.VITE_TECH5_ATS_SOCKET_API_URL_STAGING,
        ATS_API_URL: isParent
          ? import.meta.env.VITE_ATS_API_URL_STAGING
          : import.meta.env.VITE_TECH5_ATS_API_URL_STAGING,
        BENCHSALES_API_URL: import.meta.env.VITE_BENCHSALES_API_URL_STAGING,
        NONITMARKETING_API_URL: import.meta.env
          .VITE_NONITMARKETING_API_URL_STAGING,
        MIXPANEL_TOKEN_ID: import.meta.env.VITE_ATS_MIXPANEL_TOKEN_STAGING,
        ADMIN_API_URL: import.meta.env.VITE_ADMIN_API_URL_STAGING,
      };
    default:
      return {
        MAIN_API_URL: import.meta.env.VITE_MASTER_API_URL,
        WORKFORCE_API_URL: import.meta.env.VITE_WORKFORCE_API_URL,
        WORKFORCE_SOCKET_API_URL: import.meta.env.VITE_WORKFORCE_SOCKET_API_URL,
        // ATS_SOCKET_API_URL: isParent ? import.meta.env.VITE_ATS_SOCKET_API_URL : import.meta.env.VITE_TECH5_ATS_SOCKET_API_URL,
        ATS_SOCKET_API_URL: import.meta.env.VITE_ATS_SOCKET_API_URL,
        // ATS_API_URL: !isParent ? import.meta.env.VITE_ATS_API_URL : import.meta.env.VITE_TECH5_ATS_API_URL,
        ATS_API_URL: import.meta.env.VITE_ATS_API_URL,
        BENCHSALES_API_URL: import.meta.env.VITE_BENCHSALES_API_URL,
        NONITMARKETING_API_URL: import.meta.env.VITE_NONITMARKETING_API_URL,
        MIXPANEL_TOKEN_ID: import.meta.env.VITE_ATS_MIXPANEL_TOKEN_LOCAL,
        ADMIN_API_URL: import.meta.env.VITE_ADMIN_API_URL,
      };
  }
};

export const getAPI_URLS = () => getApiUrls();

export const {
  MAIN_API_URL,
  WORKFORCE_API_URL,
  ATS_API_URL,
  WORKFORCE_SOCKET_API_URL,
  NONITMARKETING_API_URL,
  BENCHSALES_API_URL,
  ATS_SOCKET_API_URL,
  MIXPANEL_TOKEN_ID,
  ADMIN_API_URL,
} = getApiUrls();

export const getEndPoints = () => {
  const {
    MAIN_API_URL,
    WORKFORCE_API_URL,
    ATS_API_URL,
    WORKFORCE_SOCKET_API_URL,
    BENCHSALES_API_URL,
    ATS_SOCKET_API_URL,
    MIXPANEL_TOKEN_ID,
    ADMIN_API_URL,
  } = getAPI_URLS();
  return {
    AUTH: {
      LOGIN: `${MAIN_API_URL}/users/login`,
      LOGOUT: `${MAIN_API_URL}/users/logout`,
      VERIFY_PASSWORD: `${MAIN_API_URL}/users/verifyPassword`,
    },
    WF_NOTIFICATIONS: {
      GET_ALL: `${WORKFORCE_API_URL}/notifications/getAll`,
      UPDATE: `${WORKFORCE_API_URL}/notifications/update`,
      GET_TOTAL_COUNT: `${WORKFORCE_API_URL}/notifications/getTotalCount`,
    },
    WF_AUTHENTICATION: {
      VERIFY_TEMP_TOKEN: `${WORKFORCE_API_URL}/authenticate-temp-token`,
      VERIFY_TEMP_LOGIN: `${WORKFORCE_API_URL}/verify-temp-access`,
    },
    MASTER_TEMPLATES: {
      GET_BY_UIID: `${MAIN_API_URL}/templates/get`,
    },
    WF_EMAILS: {
      SEND: `${WORKFORCE_API_URL}/gmail/sendMail`,
    },
    USERS: {
      GET_ALL: `${MAIN_API_URL}/users/getAll`,
      ADD: `${MAIN_API_URL}/users/add`,
      UPDATE: `${MAIN_API_URL}/users/update`,
      GET: `${MAIN_API_URL}/users/get`,
      GET_TOTAL_COUNT: `${MAIN_API_URL}/users/getTotalCount`,
      BS_GET_USERREF: `${BENCHSALES_API_URL}/userrefs/getAll`,
    },

    COUNTER: {
      GETID: `${WORKFORCE_API_URL}/counters/get`,
    },
    EMPLOYEES: {
      GET_ALL: `${WORKFORCE_API_URL}/employees/getAll`,
      GET_BY_UIID: `${WORKFORCE_API_URL}/employees/get`,
      GET_TOTAL_COUNT: `${WORKFORCE_API_URL}/employees/getTotalCount`,
      ADD_NEW: `${WORKFORCE_API_URL}/employees/add`,
      UPDATE: `${WORKFORCE_API_URL}/employees/update`,
      BULKUPDATE: `${WORKFORCE_API_URL}/employees/bulkUpdate`,
      GET_ALL_DATA: `${WORKFORCE_API_URL}/employees/GetAllData`,
    },
    ONBOARDINGS: {
      GET_ALL: `${WORKFORCE_API_URL}/onboardings/getAll`,
      GET_BY_UIID: `${WORKFORCE_API_URL}/onboardings/get`,
      GET_TOTAL_COUNT: `${WORKFORCE_API_URL}/onboardings/getTotalCount`,
      ADD_NEW: `${WORKFORCE_API_URL}/onboardings/add`,
      UPDATE: `${WORKFORCE_API_URL}/onboardings/update`,
      BULKUPDATE: `${WORKFORCE_API_URL}/onboardings/bulkUpdate`,
    },
    FUNDING_DASHBOARD: {
      FILE_PARSE: `${WORKFORCE_API_URL}/documents/file-parse`,
    },
    WF_REPORTS: {
      ADD: `${WORKFORCE_API_URL}/reports/add`,
      GET: `${WORKFORCE_API_URL}/reports/get`,
      GET_ALL: `${WORKFORCE_API_URL}/reports/getAll`,
      GET_TOTAL_COUNT: `${WORKFORCE_API_URL}/reports/getTotalCount`,
    },
    CHECKLISTS: {
      GET_ALL: `${WORKFORCE_API_URL}/checklists/getAll`,
      GET_BY_UIID: `${WORKFORCE_API_URL}/checklists/get`,
      GET_TOTAL_COUNT: `${WORKFORCE_API_URL}/checklists/getTotalCount`,
      ADD_NEW: `${WORKFORCE_API_URL}/checklists/add`,
      UPDATE: `${WORKFORCE_API_URL}/checklists/update`,
      BULKUPDATE: `${WORKFORCE_API_URL}/checklists/bulkUpdate`,
    },
    PDFTEMPLATES: {
      GET_ALL: `${WORKFORCE_API_URL}/pdftemplates/getAll`,
      GET_BY_UIID: `${WORKFORCE_API_URL}/pdftemplates/get`,
      GET_TOTAL_COUNT: `${WORKFORCE_API_URL}/pdftemplates/getTotalCount`,
      ADD_NEW: `${WORKFORCE_API_URL}/pdftemplates/add`,
      UPDATE: `${WORKFORCE_API_URL}/pdftemplates/update`,
      BULKUPDATE: `${WORKFORCE_API_URL}/pdftemplates/bulkUpdate`,
    },
    CLIENTS: {
      GET_ALL: `${WORKFORCE_API_URL}/clients/getAll`,
      GET_BY_UIID: `${WORKFORCE_API_URL}/clients/get`,
      GET_TOTAL_COUNT: `${WORKFORCE_API_URL}/clients/getTotalCount`,
      ADD_NEW: `${WORKFORCE_API_URL}/clients/add`,
      UPDATE: `${WORKFORCE_API_URL}/clients/update`,
      ADD_CONTACT: `${WORKFORCE_API_URL}/contacts/add`,
      UPDATE_CONTACT: `${WORKFORCE_API_URL}/contacts/update`,
    },
    TIMESHEETS: {
      GET_ALL: `${WORKFORCE_API_URL}/timesheets/getAll`,
      GET_BY_UIID: `${WORKFORCE_API_URL}/timesheets/get`,
      GET_TOTAL_COUNT: `${WORKFORCE_API_URL}/timesheets/getTotalCount`,
      ADD_NEW: `${WORKFORCE_API_URL}/timesheets/add`,
      UPDATE: `${WORKFORCE_API_URL}/timesheets/update`,
    },
    PLACEMENTS: {
      GET_ALL: `${WORKFORCE_API_URL}/placements/getAll`,
      GET_BY_UIID: `${WORKFORCE_API_URL}/placements/get`,
      GET_TOTAL_COUNT: `${WORKFORCE_API_URL}/placements/getTotalCount`,
      ADD_NEW: `${WORKFORCE_API_URL}/placements/add`,
      UPDATE: `${WORKFORCE_API_URL}/placements/update`,
    },
    VENDORS: {
      GET_ALL: `${WORKFORCE_API_URL}/vendors/getAll`,
      GET_BY_UIID: `${WORKFORCE_API_URL}/vendors/get`,
      GET_TOTAL_COUNT: `${WORKFORCE_API_URL}/vendors/getTotalCount`,
      ADD_NEW: `${WORKFORCE_API_URL}/vendors/add`,
      UPDATE: `${WORKFORCE_API_URL}/vendors/update`,
      ADD_CONTACT: `${WORKFORCE_API_URL}/contacts/add`,
      UPDATE_CONTACT: `${WORKFORCE_API_URL}/contacts/update`,
    },
    WORK_AUTHS: {
      GET_ALL: `${WORKFORCE_API_URL}/workauths/getAll`,
      ADD_NEW: `${WORKFORCE_API_URL}/workauths/add`,
      UPDATE: `${WORKFORCE_API_URL}/workauths/update`,
    },
    // PLACEMENTS: {
    //   GET_ALL: `${WORKFORCE_API_URL}/placements/getAll`,
    //   GET_BY_UIID: `${WORKFORCE_API_URL}/placements/get`,
    //   ADD_NEW: `${WORKFORCE_API_URL}/placements/add`,
    //   UPDATE: `${WORKFORCE_API_URL}/placements/update`,
    // },
    IMMIGRATION: {
      GET_BY_UIID: `${WORKFORCE_API_URL}/immigrations/get`,
      ADD_NEW: `${WORKFORCE_API_URL}/immigrations/add`,
      UPDATE: `${WORKFORCE_API_URL}/immigrations/update`,
    },
    LCA: {
      GET_BY_UIID: `${WORKFORCE_API_URL}/lcas/get`,
      GET_ALL: `${WORKFORCE_API_URL}/lcas/getAll`,
      ADD_NEW: `${WORKFORCE_API_URL}/lcas/add`,
      UPDATE: `${WORKFORCE_API_URL}/lcas/update`,
    },
    H1B: {
      GET_BY_UIID: `${WORKFORCE_API_URL}/h1bs/get`,
      GET_ALL: `${WORKFORCE_API_URL}/h1bs/getAll`,
      ADD_NEW: `${WORKFORCE_API_URL}/h1bs/add`,
      UPDATE: `${WORKFORCE_API_URL}/h1bs/update`,
    },
    VISA: {
      GET_BY_UIID: `${WORKFORCE_API_URL}/visas/get`,
      GET_ALL: `${WORKFORCE_API_URL}/visas/getAll`,
      ADD_NEW: `${WORKFORCE_API_URL}/visas/add`,
      UPDATE: `${WORKFORCE_API_URL}/visas/update`,
    },

    JOBNADVS: {
      GET_BY_UIID: `${WORKFORCE_API_URL}/jobnadvs/get`,
      GET_ALL: `${WORKFORCE_API_URL}/jobnadvs/getAll`,
      ADD_NEW: `${WORKFORCE_API_URL}/jobnadvs/add`,
      UPDATE: `${WORKFORCE_API_URL}/jobnadvs/update`,
    },
    DOCUMENT: {
      GET_ALL: `${WORKFORCE_API_URL}/documents/getAll`,
      ADD_TAXFORM: `${WORKFORCE_API_URL}/emptaxforms/add`,
      GET_ALL_TAXFORM: `${WORKFORCE_API_URL}/emptaxforms/getAll`,
    },
    UNIVERSAL: {
      UPLOAD_FILE: `${WORKFORCE_API_URL}`,
      DOCUMENT_ADD: `${WORKFORCE_API_URL}/documents/add`,
      GET_S3_LINK: `${WORKFORCE_API_URL}/documents/getSignUrl?coll=Document`,
    },

    GET_TOTAL_COUNT: `${WORKFORCE_API_URL}`,
    GET_TOTAL_COUNT_ATS: `${ATS_API_URL}`,
    GET_TOTAL_COUNT_MASTER: `${MAIN_API_URL}`,
    GET_TOTAL_COUNT_BENCHSALES: `${BENCHSALES_API_URL}`,
    ACCOUNT_PAYBLES: {
      GET_ALL: `${WORKFORCE_API_URL}/accountpayables/getAll`,
      GET_BY_UIID: `${WORKFORCE_API_URL}/accountpayables/get`,
      ADD_NEW: `${WORKFORCE_API_URL}/accountpayables/add`,
      UPDATE: `${WORKFORCE_API_URL}/accountpayables/update`,
    },
    INVOICES: {
      GET_ALL: `${WORKFORCE_API_URL}/invoices/getAll`,
      GET_BY_UIID: `${WORKFORCE_API_URL}/invoices/get`,
      ADD_NEW: `${WORKFORCE_API_URL}/invoices/add`,
      UPDATE: `${WORKFORCE_API_URL}/invoices/update`,
      BULKUPDATE: `${WORKFORCE_API_URL}/invoices/bulkUpdate`,
    },

    INCENTIVES: {
      GET_ALL: `${WORKFORCE_API_URL}/incentives/getAll`,
      GET_BY_UIID: `${WORKFORCE_API_URL}/incentives/get`,
      ADD_NEW: `${WORKFORCE_API_URL}/incentives/add`,
      UPDATE: `${WORKFORCE_API_URL}/incentives/update`,
      DELETE: `${WORKFORCE_API_URL}/incentives/delete`,
      GET_TOTAL_COUNT: `${WORKFORCE_API_URL}/incentives/getTotalCount`,
      GET_SHEET: `${WORKFORCE_API_URL}/incentives/sheet`,
      GET_SUMMARY: `${WORKFORCE_API_URL}/incentives/summary`,
    },
    INCENTIVE_SETTINGS: {
      GET_BY_KEY: `${WORKFORCE_API_URL}/incentivesettings/get`,
      ADD: `${WORKFORCE_API_URL}/incentivesettings/add`,
      UPDATE: `${WORKFORCE_API_URL}/incentivesettings/update`,
    },

    PAYROLL_SALARYY_PROFILE: {
      GET_ALL: `${WORKFORCE_API_URL}/salaryprofiles/getAll`,
      GET_BY_UIID: `${WORKFORCE_API_URL}/salaryprofiles/get`,
      ADD_NEW: `${WORKFORCE_API_URL}/salaryprofiles/add`,
      UPDATE: `${WORKFORCE_API_URL}/salaryprofiles/update`,
    },
    EMPLOYEE_PAY_CONFIGURATION: {
      GET_ALL: `${WORKFORCE_API_URL}/emppayconfigs/getAll`,
      GET_BY_UIID: `${WORKFORCE_API_URL}/emppayconfigs/get`,
      ADD_NEW: `${WORKFORCE_API_URL}/emppayconfigs/add`,
      UPDATE: `${WORKFORCE_API_URL}/emppayconfigs/update`,
    },
    PAYROLL: {
      GET_ALL: `${WORKFORCE_API_URL}/payrolls/getAll`,
      GET_BY_UIID: `${WORKFORCE_API_URL}/payrolls/get`,
      ADD_NEW: `${WORKFORCE_API_URL}/payrolls/add`,
      UPDATE: `${WORKFORCE_API_URL}/payrolls/update`,
      GET_TOTAL_COUNT: `${WORKFORCE_API_URL}/payrolls/getTotalCount`,
    },
    EMPLOYEE_DEDUCTIONS: {
      GET_ALL: `${WORKFORCE_API_URL}/empdeductions/getAll`,
      GET_BY_UIID: `${WORKFORCE_API_URL}/empdeductions/get`,
      ADD_NEW: `${WORKFORCE_API_URL}/empdeductions/add`,
      UPDATE: `${WORKFORCE_API_URL}/empdeductions/update`,
    },
    EMPLOYEE_OTHER_PAYMENTS: {
      GET_ALL: `${WORKFORCE_API_URL}/empotherpays/getAll`,
      GET_BY_UIID: `${WORKFORCE_API_URL}/empotherpays/get`,
      ADD_NEW: `${WORKFORCE_API_URL}/empotherpays/add`,
      UPDATE: `${WORKFORCE_API_URL}/empotherpays/update`,
    },
    RECONCILIATION: {
      GET_ALL: `${WORKFORCE_API_URL}/reconciliations/getAll`,
      GET_BY_UIID: `${WORKFORCE_API_URL}/reconciliations/get`,
      ADD_NEW: `${WORKFORCE_API_URL}/reconciliations/add`,
      UPDATE: `${WORKFORCE_API_URL}/reconciliations/parse-xlsx`,
      GET_TOTAL_COUNT: `${WORKFORCE_API_URL}/reconciliations/getTotalCount`,
    },
    EMPLOYEE_BONUS: {
      GET_ALL: `${WORKFORCE_API_URL}/empbonuspays/getAll`,
      GET_BY_UIID: `${WORKFORCE_API_URL}/empbonuspays/get`,
      ADD_NEW: `${WORKFORCE_API_URL}/empbonuspays/add`,
      UPDATE: `${WORKFORCE_API_URL}/empbonuspays/update`,
      GET_TOTAL_COUNT: `${WORKFORCE_API_URL}/empbonuspays/getTotalCount`,
    },
    EMPLOYEE_ADJUSTMENTS: {
      GET_ALL: `${WORKFORCE_API_URL}/empadjustments/getAll`,
      GET_TOTAL_COUNT: `${WORKFORCE_API_URL}/empadjustments/getTotalCount`,
    },
    MISC: {
      RUN_SERVER_TASKS: `${WORKFORCE_API_URL}/server-tasks`,
    },
    INCOMING_PLACEMENTS: {
      GET_ALL: `${WORKFORCE_API_URL}/incomingplacements/getAll`,
      GET_TOTAL_COUNT: `${WORKFORCE_API_URL}/incomingplacements/getTotalCount`,
      PUSH: `${WORKFORCE_API_URL}/placements/incoming`,
      APPROVE: `${WORKFORCE_API_URL}/placements/incoming`,
      UPDATE: `${WORKFORCE_API_URL}/incomingplacements/update`,
    },
    COMPANIES: {
      GET_ALL: `${ATS_API_URL}/companys/getAll`,
      GET_BY_UIID: `${ATS_API_URL}/companys/get`,
      ADD_NEW: `${ATS_API_URL}/companys/add`,
      DELETE: `${ATS_API_URL}/companys/delete`,
      UPDATE: `${ATS_API_URL}/companys/update`,
      MERGE: `${ATS_API_URL}/companys/mergeCompany`,
    },
    SYSTEMSTATS: {
      GET_ALL: `${ATS_API_URL}/systemstats/getAll`,
    },
    PROSPECTS: {
      GET_ALL: `${ATS_API_URL}/prospects/getAll`,
      GET: `${ATS_API_URL}/prospects/get`,
      BULK_UPDATE: `${ATS_API_URL}/prospects/bulkUpdate`,
      UPDATE: `${ATS_API_URL}/prospects/update`,
    },
    CITIES: {
      GET_ALL: `${MAIN_API_URL}/cities/getAll`,
      DELETE: `${MAIN_API_URL}/cities/delete`,
    },
    COUNTRIES: {
      GET_ALL: `${MAIN_API_URL}/countries/getAll`,
    },
    STATES: {
      ADD_NEW_LOCATION: `${MAIN_API_URL}/states/locations/add`,
      GET_ALL: `${MAIN_API_URL}/states/getAll`,
      DELETE: `${MAIN_API_URL}/states/delete`,
    },

    // STATES: {
    //   ADD_NEW_LOCATION: `${MAIN_API_URL}/states/locations/add`,
    //   GET_ALL: `${MAIN_API_URL}/states/getAll`,
    //   DELETE: `${MAIN_API_URL}/states/delete`,
    // },

    //here  first defined for ats , now we are hanging to benchsales api url
    JOBS: {
      GET_ALL: `${ATS_API_URL}/jobs/getAll`,
      GET: `${ATS_API_URL}/jobs/get`,
      ADD: `${ATS_API_URL}/jobs/add`,
      DELETE: `${ATS_API_URL}/jobs/delete`,
      UPDATE: `${ATS_API_URL}/jobs/update`,
    },
    TEAMLEAD: {
      GET_ALL: `${ATS_API_URL}/companys/getAll`,
    },
    JOBPOSTINGS: {
      ADD: `${ATS_API_URL}/jobpostings/add`,
      GET_ALL: `${ATS_API_URL}/jobpostings/getAll`,
      GET: `${ATS_API_URL}/jobpostings/get`,
      UPDATE: `${ATS_API_URL}/jobpostings/update`,
      //GET_QUESTIONS:`${ATS_API_URL}/jobpostquestions/getAll`
    },
    SETTINGS: {
      GET_ALL: `${ATS_API_URL}/settings/getAll`,
      ADD: `${ATS_API_URL}/settings/add`,
      UPDATE: `${ATS_API_URL}/settings/update`,
    },
    EMAILTEMPLATE: {
      GET_ALL: `${ATS_API_URL}/templates/getAll`,
      ADD: `${ATS_API_URL}/templates/add`,
      DELETE: `${ATS_API_URL}/templates/delete`,
      GET: `${ATS_API_URL}/templates/get`,
      UPDATE: `${ATS_API_URL}/templates/update`,
    },

    BDMJOBS: {
      GET_ALL: `${ATS_API_URL}/submissions/getAll`,
    },
    NOTES: {
      ADD: `${ATS_API_URL}/notes/add`,
      GET_ALL: `${ATS_API_URL}/notes/getAll`,
      DELETE: `${ATS_API_URL}/notes/delete`,
    },
    INTEGRATIONS: {
      GET: `${ATS_API_URL}/integrations/get`,
      ADD: `${ATS_API_URL}/integrations/add`,
      UPDATE: `${ATS_API_URL}/integrations/update`,
      POST: `${ATS_API_URL}/integration/internal-db-resume-download`,
      GET_ALL: `${ATS_API_URL}/integrations/getAll`,
      DELETE: `${ATS_API_URL}/integrations/delete`,
    },
    INTEGRATION_ACCESS: {
      GET: `${ATS_API_URL}/integrationaccesss/get`,
      GET_ALL: `${ATS_API_URL}/integrationaccesss/getAll`,
      UPDATE: `${ATS_API_URL}/integrationaccesss/update`,
      ADD: `${ATS_API_URL}/integrationaccesss/add`,
    },
    RECRUITEMENT: {
      GET_ALL: `${ATS_API_URL}/candidates/getAll`,
    },

    ROLES: {
      GET_ALL: `${MAIN_API_URL}/roles/getAll`,
      ADD: `${MAIN_API_URL}/roles/add`,
      DELETE: `${MAIN_API_URL}/roles/delete`,
      UPDATE: `${MAIN_API_URL}/roles/update`,
      GET: `${MAIN_API_URL}/roles/get`,
    },

    SHUFFLE: {
      ADD: `${ATS_API_URL}/shuffles/add`,
      GET_ALL: `${ATS_API_URL}/shuffles/getAll`,
    },
    ORGANIZATIONS: {
      UPDATE: `${MAIN_API_URL}/organizations/update`,
      GET: `${MAIN_API_URL}/organizations/get`,
      UPLOAD: `${MAIN_API_URL}/organizations/upload`,
      GET_IMAGE_S3_LINK: `${MAIN_API_URL}/organizations/getSignUrl?coll=Organization`,
    },
    SUBMISSOINS: {
      UPDATE: `${ATS_API_URL}/submissions/update`,
      GET_ALL: `${ATS_API_URL}/submissions/getAll`,
      POST: `${ATS_API_URL}/submissions/add`,
      PUSH_TO_WORKFORCE: `${ATS_API_URL}/submissions/push-to-workforce`,
    },
    SEARCH: {
      MONSTER_SEARCH: `${ATS_API_URL}/integration/monster-search`,
      MONSTER_RESUME_IMPORT: `${ATS_API_URL}/integration/monster-resume-import`,
      MONSTER_RESUMES_IMPORT: `${ATS_API_URL}/integration/monster-resumes-import`,
      CAREER_BUILDER_SEARCH: `${ATS_API_URL}/integration/careerbuilder-search`,
      CAREER_BUILDER_RESUME_IMPORT: `${ATS_API_URL}/integration/careerbuilder-resume-import`,
      CAREER_BUILDER_RESUMES_IMPORT: `${ATS_API_URL}/integration/careerbuilder-resumes-import`,
      INTERNAL_DB: `${ATS_API_URL}/integration/internaldb-search`,
    },
    INSTANTLY: {
      GET_CAMPAIGN: `${ATS_API_URL}/integration/instantly-get-campaign`,
      GETALL_CAMPAIGN: `${ATS_API_URL}/integration/instanly-getall-campaign`,
      GET_BULK_ANALYST: `${ATS_API_URL}/integration/instantly-getbulk-analyst`,
      ADD_CAMPAIGN: `${ATS_API_URL}/integration/instantly-create-campaign`,
      PAUSE_CAMPAIGN: `${ATS_API_URL}/integration/instantly-pause-campaign`,
      START_CAMPAIGN: `${ATS_API_URL}/integration/instantly-start-campaign`,
      DELETE_CAMPAIGN: `${ATS_API_URL}/integration/instantly-delete-campaign`,
      UPDATE_CAMPAIGN: `${ATS_API_URL}/integration/instantly-update-campaign`,
      DUPLICATE_CAMPAIGN: `${ATS_API_URL}/integration/instantly-duplicate-campaign`,
    },
    JOB_BOARDS_HISTORY: {
      HISTORY: `${ATS_API_URL}/jobboardshistory`,
      ADD: `${ATS_API_URL}/jobboardshistory`, //for integrated search to add history
    },
    // signatures
    SIGNATURES: {
      GET: `${ATS_API_URL}/signatures/get`,
      UPDATE: `${ATS_API_URL}/signatures/update`,
      GET_ALL: `${ATS_API_URL}/signatures/getAll`,
      ADD: `${ATS_API_URL}/signatures/add`,
    },
    // prospectEmailLogs
    PROSPECTEMAILLOGS: {
      GET: `${ATS_API_URL}/prospectemaillogs/get`,
      UPDATE: `${ATS_API_URL}/prospectemaillogs/update`,
      GET_ALL: `${ATS_API_URL}/prospectemaillogs/getAll`,
      ADD: `${ATS_API_URL}/prospectemaillogs/add`,
    },

    CANDIDATES: {
      GET_ALL: `${ATS_API_URL}/candidates/getAll`,
      ADD: `${ATS_API_URL}/candidates/add`,
      GET: `${ATS_API_URL}/candidates/get`,
      UPDATE: `${ATS_API_URL}/candidates/update`,
      RESUME_URL: `${ATS_API_URL}/candidates/getSignUrl`,
      RESUME_PARSER: `${ATS_API_URL}/candidates/resume-parser`,
      BULK_RESUME_PARSER: `${ATS_API_URL}/candidates/bulk-resume-parser`,
    },

    JOB_BOARDS_CREDIT_HISTORY: {
      GET_ALL: `${ATS_API_URL}/jobboardcredithistorys/getAll`,
      ADD: `${ATS_API_URL}/jobboardcredithistorys/add`,
    },

    RESUME_MINING: {
      GET_ALL: `${ATS_API_URL}/resumeminings/getAll`,
      ADD: `${ATS_API_URL}/resumeminings/add`,
      DELETE: `${ATS_API_URL}/resumeminings/delete`,
      UPDATE: `${ATS_API_URL}/resumeminings/update`,
    },
    RESUME_MINING_HISTORY: {
      GET_ALL: `${ATS_API_URL}/resumemininghistorys/getAll`,
    },
    PUSH_DATA_TO_WORKFORCE: {
      GET: `${ATS_API_URL}/submissions/getAll`,
    },
    KULT_FETCH: {
      GET_ALL: `${ATS_API_URL}/kultfetches/getAll`,
    },
    HOTLIST: {
      GET_ALL: `${ATS_API_URL}/hotlists/getAll`,
    },
    TALENT_MATCH: {
      GET_ALL: `${ATS_API_URL}/talentmatches/getAll`,
      UPDATE: `${ATS_API_URL}/talentmatches/update`,
      BULK_UPDATE: `${ATS_API_URL}/talentmatches/bulkUpdate`,
    },
    ATS_UNIVERSAL: {
      UPLOAD_FILE: `${ATS_API_URL}`,
      DOCUMENT_ADD: `${ATS_API_URL}/documents/add`,
      GET_S3_LINK: `${ATS_API_URL}/documents/getSignUrl?coll=Document`,
    },
    EMAIL: {
      POST: `${ATS_API_URL}/candidateemaillogs/add`,
      GET: `${ATS_API_URL}/candidateemaillogs/getTotalCount`,
      GET_ALL: `${ATS_API_URL}/candidateemaillogs/getAll`,
      GET_ALL_CAMPAIGNS: `${ATS_API_URL}/emailcampaigns/getAll`,
    },
    LOCAL_RESTRICTIONS: {
      ADD: `${ATS_API_URL}/locationrestrictions/add`,
      GET_ALL: `${ATS_API_URL}/locationrestrictions/getAll`,
      DELETE: `${ATS_API_URL}/locationrestrictions/delete`,
    },
    REPORTS: {
      GET_ALL: `${ATS_API_URL}/reports/getAll`,
    },
    FAVOURITE_REPORTS: {
      GET_ALL: `${ATS_API_URL}/favouritereports/getAll`,
      ADD: `${ATS_API_URL}/favouritereports/add`,
      DELETE: `${ATS_API_URL}/favouritereports/delete`,
    },
    AICALLS: {
      ADD: `${ATS_API_URL}/aicalls/add`,
      GET_ALL: `${ATS_API_URL}/aicalls/getAll`,
      GET_DETAILS: `${ATS_API_URL}/integration/kult-ai-call`,
      UPDATE: `${ATS_API_URL}/aicalls/update`,
    },
    CANDIDATE: {
      GET_ALL: `${BENCHSALES_API_URL}/candidates/getAll`,
      GET_BY_ID: `${BENCHSALES_API_URL}/candidates/getById`,
      ADD: `${BENCHSALES_API_URL}/candidates/add`,
      GET: `${BENCHSALES_API_URL}/candidates/get`,
      UPDATE: `${BENCHSALES_API_URL}/candidates/update`,
      GET_TOTAL_COUNT_CANDIDATE: `${BENCHSALES_API_URL}/candidates/getTotalCount`,
      UPLOAD: `${BENCHSALES_API_URL}/candidates/upload`,
      ANALYZE: `${BENCHSALES_API_URL}/candidates/analyze`,
      RESUME_PARSER: `${BENCHSALES_API_URL}/candidates/resume-parser`,
      GET_TOTAL_USER_COUNT: `${BENCHSALES_API_URL}/candidates/getTotalUsersCount`,
      GET_DOC: `${BENCHSALES_API_URL}/candidates/getSignUrl`,
      DELETE: `${BENCHSALES_API_URL}/candidates/delete`,
    },
    JOB: {
      GET_ALL: `${BENCHSALES_API_URL}/jobs/getAll`,
      GET_TOTAL_COUNT: `${BENCHSALES_API_URL}/jobs/getTotalUsersCount`,
      ADD: `${BENCHSALES_API_URL}/jobs/add`,
      UPDATE: `${BENCHSALES_API_URL}/jobs/update`,
    },
    CONTACTS: {
      ADD: `${BENCHSALES_API_URL}/contacts/add`,
      VERIFY: `${BENCHSALES_API_URL}/contacts/verify`,
      GET_ALL: `${BENCHSALES_API_URL}/contacts/getAll`,
      GET: `${BENCHSALES_API_URL}/contacts/get`,
      UPDATE: `${BENCHSALES_API_URL}/contacts/update`,
      DELETE: `${BENCHSALES_API_URL}/contacts/delete`,
    },
    SUBMISSION: {
      ADD: `${BENCHSALES_API_URL}/submissions/add`,
      GET_ALL: `${BENCHSALES_API_URL}/submissions/getAll`,
      GET_TOTAL_COUNT_SUBMISSION: `${BENCHSALES_API_URL}/submissions/getTotalCount`,
    },
    USER_REFS: {
      ATS_USER_GET_ALL: `${ATS_API_URL}/userrefs/getAll`,
      ATS_USER_COUNT: `${ATS_API_URL}/userrefs/count`,
      ATS_USER_HIERARCHY: `${ATS_API_URL}/userrefs/getRepotingHierarchy`,
      WF_USER_GET_ALL: `${WORKFORCE_API_URL}/userrefs/getAll`,
      WF_USER_COUNT: `${WORKFORCE_API_URL}/userrefs/count`,
      ATS_GET_LEADS_MANAGERS: `${ATS_API_URL}/userrefs/getManager`,
      GET_NON_IT_USERS: `${ATS_API_URL}/userrefs/getNonItMarketingRecruiters`,
    },
    BUILD_VERSION: {
      ADD: `${ATS_API_URL}/buildversions/add`,
      GET_ALL: `${ATS_API_URL}/buildversions/getAll`,
    },
    ENGAGEMENT_STATUS: {
      ADD: `${ATS_API_URL}/engagementstatuss/add`,
      GET_ALL: `${ATS_API_URL}/engagementstatuss/getAll`,
    },
    INTERVIEW: {
      ADD: `${BENCHSALES_API_URL}/interviews/add`,
      GET_ALL: `${BENCHSALES_API_URL}/interviews/getAll`,
      GET_TOTAL_COUNT_INTERVIEWS: `${BENCHSALES_API_URL}/interviews/getTotalCount`,
      GET_TOTAL_MAIN_COUNT: `${BENCHSALES_API_URL}/interviews/getTotalMainCount`,
    },
    BS_REPORTS: {
      GET_ALL: `${BENCHSALES_API_URL}/reports/getAll`,
    },
    BS_TEMPLATES: {
      ADD: `${BENCHSALES_API_URL}/templates/add`,
      GET_ALL: `${BENCHSALES_API_URL}/templates/getAll`,
      DELETE: `${BENCHSALES_API_URL}/templates/delete`,
      UPDATE: `${BENCHSALES_API_URL}/templates/update`,
    },
    BS_CONTACTS: {
      POST: `${BENCHSALES_API_URL}/apollo/peoples`,
      POST_EMAIL: `${BENCHSALES_API_URL}/apollo/profiles?getEmail=true`,
      AUTH: `${BENCHSALES_API_URL}/apollo/auth`,
    },
    BS_AUTH: {
      UPDATE: `${BENCHSALES_API_URL}/authtokens/updateByEmail`,
    },
    BS_EMAILLOGS: {
      ADD: `${BENCHSALES_API_URL}/emaillogs/add`,
    },
    BS_GMAIL: {
      GMAIL_AUTH: `${BENCHSALES_API_URL}/gmail/auth`,
      GET_GMAIL: `${BENCHSALES_API_URL}/gmail/accounts`,
    },
    BS_OUTLOOK: {
      OUTLOOK_AUTH: `${BENCHSALES_API_URL}/outlook/auth`,
      GET_OUTLOOK: `${BENCHSALES_API_URL}/outlook/accounts`,
    },
    BS_MAIL_ACCOUNT: {
      ASSIGN_ACCESS: `${BENCHSALES_API_URL}/assign-access`,
    },
    EMAILACCOUNT: {
      GET_ALL: `${BENCHSALES_API_URL}/emailaccounts/getAll`,
      GET_TOTAL_COUNT: `${BENCHSALES_API_URL}/emailaccounts/getTotalUsersCount`,
      UPDATE: `${BENCHSALES_API_URL}/emailaccounts/updateAccessStatus`,
      DELETE: `${BENCHSALES_API_URL}/emailaccounts/delete`,
    },

    PLACEMENT: {
      ADD: `${BENCHSALES_API_URL}/placements/add`,
      GET_ALL: `${BENCHSALES_API_URL}/placements/getAll`,
      GET_TOTAL_COUNT_PLACEMENTS: `${BENCHSALES_API_URL}/placements/getTotalCount`,
    },
    USEREF: {
      GET_ALL: `${BENCHSALES_API_URL}/userrefs/getAll`,
      GET_TOTAL_COUNT: `${BENCHSALES_API_URL}/userrefs/count`,
    },
    CANDIDATEVERSION: {
      GET_ALL: `${BENCHSALES_API_URL}/candidateversions/getAll`,
      DELETE: `${BENCHSALES_API_URL}/candidateversions/delete`,
    },
    OPTIMISERESUME: {
      GET_ALL: `${BENCHSALES_API_URL}/algorithm/kult`,
    },
    AIDRAFT: {
      GET_ALL: `${BENCHSALES_API_URL}/content/draft`,
    },

    BS_COMPANIES: {
      GET_ALL: `${BENCHSALES_API_URL}/companys/getAll`,
      ADD: `${BENCHSALES_API_URL}/companys/add`,
    },
    BS_INTEGRATION_ACCESS: {
      GET_ALL: `${BENCHSALES_API_URL}/integrationaccesses/getAll`,
      ADD: `${BENCHSALES_API_URL}/integrationaccess/add`,
    },
    LEAD_COMPANY: {
      GET_ALL: `${ATS_API_URL}/leadcompanys/getAll`,
      GET: `${ATS_API_URL}/leadcompanys/get`,
      AGREEMENT_URL: `${ATS_API_URL}/leadcompanys/getSignUrl`,
      ADD: `${ATS_API_URL}/leadcompanys/add`,
      UPDATE: `${ATS_API_URL}/leadcompanys/update`,
      DELETE: `${ATS_API_URL}/leadcompanys/delete`,
    },
    LEAD_JOB: {
      GET_ALL: `${ATS_API_URL}/leadjobs/getAll`,
      ADD: `${ATS_API_URL}/leadjobs/add`,
      UPDATE: `${ATS_API_URL}/leadjobs/update`,
    },
    LEAD_CONTACT: {
      GET_ALL: `${ATS_API_URL}/leadcontacts/getAll`,
      ADD: `${ATS_API_URL}/leadcontacts/add`,
      UPDATE: `${ATS_API_URL}/leadcontacts/update`,
    },
    BENCHSALES_HOTLIST: {
      GET_ALL: `${BENCHSALES_API_URL}/hotlists/getAll`,
      ADD: `${BENCHSALES_API_URL}/hotlists/add`,
      UPDATE: `${BENCHSALES_API_URL}/hotlists/update`,
      DELETE: `${BENCHSALES_API_URL}/hotlists/delete`,
    },
    VOICE_CALL: {
      CLICK_TO_CALL: `${BENCHSALES_API_URL}/click2call`,
    },

    INTEGRATION_BS: {
      GET_ALL: `${BENCHSALES_API_URL}/integrationbss/getAll`,
      ADD: `${BENCHSALES_API_URL}/integrationbss/add`,
      UPDATE: `${BENCHSALES_API_URL}/integrationbss/update`,
      DELETE: `${BENCHSALES_API_URL}/integrationbss/delete`,
    },
    INTEGRATION_ACCESS_BS: {
      GET: `${BENCHSALES_API_URL}/integrationaccesss/get`,
      GET_ALL: `${BENCHSALES_API_URL}/integrationaccesss/getAll`,
      UPDATE: `${BENCHSALES_API_URL}/integrationaccesss/update`,
      ADD: `${BENCHSALES_API_URL}/integrationaccesss/add`,
    },
    CREDIT_HISTORY_BS: {
      GET_ALL: `${BENCHSALES_API_URL}/credithistorys/getAll`,
      ADD: `${BENCHSALES_API_URL}/credithistorys/add`,
    },
    SETTINGS_BS: {
      GET_ALL: `${BENCHSALES_API_URL}/settings`,
    },
    CANDIDATE_PLATFORM_CREDENTIALS: {
      ADD: `${BENCHSALES_API_URL}/candidateplatformcredentials/add`,
      GET_ALL: `${BENCHSALES_API_URL}/candidateplatformcredentials/getAll`,
      UPDATE: `${BENCHSALES_API_URL}/candidateplatformcredentials/update`,
    },
    TICKET: {
      ADD: `${ADMIN_API_URL}/tickets/add`,
    },
    PUBLIC: {
      GET_ORG_BASE_URL: `${MAIN_API_URL}/view/organizations`,
    },
    IP: {
      GET_ALL: `${MAIN_API_URL}/ipwhitelists/getAll`,
      ADD: `${MAIN_API_URL}/ipwhitelists/add`,
      UPDATE: `${MAIN_API_URL}/ipwhitelists/update`,
      DELETE: `${MAIN_API_URL}/ipwhitelists/delete`,
    },
    CANDIDATE_NM: {
      GET_ALL: `${NONITMARKETING_API_URL}/candidates/getAll`,
      GET_BY_ID: `${NONITMARKETING_API_URL}/candidates/getById`,
      ADD: `${NONITMARKETING_API_URL}/candidates/add`,
      GET: `${NONITMARKETING_API_URL}/candidates/get`,
      UPDATE: `${NONITMARKETING_API_URL}/candidates/update`,
      GET_TOTAL_COUNT_CANDIDATE: `${NONITMARKETING_API_URL}/candidates/getTotalCount`,
      UPLOAD: `${NONITMARKETING_API_URL}/candidates/upload`,
      ANALYZE: `${NONITMARKETING_API_URL}/candidates/analyze`,
      RESUME_PARSER: `${NONITMARKETING_API_URL}/candidates/resume-parser`,
      GET_TOTAL_USER_COUNT: `${NONITMARKETING_API_URL}/candidates/getTotalUsersCount`,
      GET_DOC: `${NONITMARKETING_API_URL}/candidates/getSignUrl`,
      DELETE: `${NONITMARKETING_API_URL}/candidates/delete`,
    },
    JOB_NM: {
      GET_ALL: `${NONITMARKETING_API_URL}/jobs/getAll`,
      GET_TOTAL_COUNT: `${NONITMARKETING_API_URL}/jobs/getTotalUsersCount`,
      ADD: `${NONITMARKETING_API_URL}/jobs/add`,
      UPDATE: `${NONITMARKETING_API_URL}/jobs/update`,
    },
    CONTACTS_NM: {
      ADD: `${NONITMARKETING_API_URL}/contacts/add`,
      VERIFY: `${NONITMARKETING_API_URL}/contacts/verify`,
      GET_ALL: `${NONITMARKETING_API_URL}/contacts/getAll`,
      GET: `${NONITMARKETING_API_URL}/contacts/get`,
      UPDATE: `${NONITMARKETING_API_URL}/contacts/update`,
      DELETE: `${NONITMARKETING_API_URL}/contacts/delete`,
    },
    SUBMISSION_NM: {
      ADD: `${NONITMARKETING_API_URL}/submissions/add`,
      GET_ALL: `${NONITMARKETING_API_URL}/submissions/getAll`,
      GET_TOTAL_COUNT_SUBMISSION: `${NONITMARKETING_API_URL}/submissions/getTotalCount`,
    },
    INTERVIEW_NM: {
      ADD: `${NONITMARKETING_API_URL}/interviews/add`,
      GET_ALL: `${NONITMARKETING_API_URL}/interviews/getAll`,
      GET_TOTAL_COUNT_INTERVIEWS: `${NONITMARKETING_API_URL}/interviews/getTotalCount`,
      GET_TOTAL_MAIN_COUNT: `${NONITMARKETING_API_URL}/interviews/getTotalMainCount`,
    },
    NM_REPORTS: {
      GET_ALL: `${NONITMARKETING_API_URL}/reports/getAll`,
    },
    NM_TEMPLATES: {
      ADD: `${NONITMARKETING_API_URL}/templates/add`,
      GET_ALL: `${NONITMARKETING_API_URL}/templates/getAll`,
      DELETE: `${NONITMARKETING_API_URL}/templates/delete`,
      UPDATE: `${NONITMARKETING_API_URL}/templates/update`,
    },
    NM_CONTACTS: {
      POST: `${NONITMARKETING_API_URL}/apollo/peoples`,
      POST_EMAIL: `${NONITMARKETING_API_URL}/apollo/profiles?getEmail=true`,
      AUTH: `${NONITMARKETING_API_URL}/apollo/auth`,
    },
    NM_AUTH: {
      UPDATE: `${NONITMARKETING_API_URL}/authtokens/updateByEmail`,
    },
    NM_EMAILLOGS: {
      ADD: `${NONITMARKETING_API_URL}/emaillogs/add`,
    },
    NM_GMAIL: {
      GMAIL_AUTH: `${NONITMARKETING_API_URL}/gmail/auth`,
      GET_GMAIL: `${NONITMARKETING_API_URL}/gmail/accounts`,
    },
    NM_OUTLOOK: {
      OUTLOOK_AUTH: `${NONITMARKETING_API_URL}/outlook/auth`,
      GET_OUTLOOK: `${NONITMARKETING_API_URL}/outlook/accounts`,
    },
    NM_MAIL_ACCOUNT: {
      ASSIGN_ACCESS: `${NONITMARKETING_API_URL}/assign-access`,
    },
    EMAILACCOUNT_NM: {
      GET_ALL: `${NONITMARKETING_API_URL}/emailaccounts/getAll`,
      GET_TOTAL_COUNT: `${NONITMARKETING_API_URL}/emailaccounts/getTotalUsersCount`,
      UPDATE: `${NONITMARKETING_API_URL}/emailaccounts/updateAccessStatus`,
      DELETE: `${NONITMARKETING_API_URL}/emailaccounts/delete`,
    },

    PLACEMENT_NM: {
      ADD: `${NONITMARKETING_API_URL}/placements/add`,
      GET_ALL: `${NONITMARKETING_API_URL}/placements/getAll`,
      GET_TOTAL_COUNT_PLACEMENTS: `${NONITMARKETING_API_URL}/placements/getTotalCount`,
    },
    USEREF_NM: {
      GET_ALL: `${NONITMARKETING_API_URL}/userrefs/getAll`,
      GET_TOTAL_COUNT: `${NONITMARKETING_API_URL}/userrefs/count`,
    },
    CANDIDATEVERSION_NM: {
      GET_ALL: `${NONITMARKETING_API_URL}/candidateversions/getAll`,
      DELETE: `${NONITMARKETING_API_URL}/candidateversions/delete`,
    },
    OPTIMISERESUME_NM: {
      GET_ALL: `${NONITMARKETING_API_URL}/algorithm/kult`,
    },
    AIDRAFT_NM: {
      GET_ALL: `${NONITMARKETING_API_URL}/content/draft`,
    },

    NM_COMPANIES: {
      GET_ALL: `${NONITMARKETING_API_URL}/companys/getAll`,
      ADD: `${NONITMARKETING_API_URL}/companys/add`,
    },
    NM_INTEGRATION_ACCESS: {
      GET_ALL: `${NONITMARKETING_API_URL}/integrationaccesses/getAll`,
      ADD: `${NONITMARKETING_API_URL}/integrationaccess/add`,
    },
    NM_HOTLIST: {
      GET_ALL: `${NONITMARKETING_API_URL}/hotlists/getAll`,
      ADD: `${NONITMARKETING_API_URL}/hotlists/add`,
      UPDATE: `${NONITMARKETING_API_URL}/hotlists/update`,
      DELETE: `${NONITMARKETING_API_URL}/hotlists/delete`,
    },
    INTEGRATION_NM: {
      GET_ALL: `${NONITMARKETING_API_URL}/integrationbss/getAll`,
      ADD: `${NONITMARKETING_API_URL}/integrationbss/add`,
      UPDATE: `${NONITMARKETING_API_URL}/integrationbss/update`,
      DELETE: `${NONITMARKETING_API_URL}/integrationbss/delete`,
    },
    INTEGRATION_ACCESS_NM: {
      GET: `${NONITMARKETING_API_URL}/integrationaccesss/get`,
      GET_ALL: `${NONITMARKETING_API_URL}/integrationaccesss/getAll`,
      UPDATE: `${NONITMARKETING_API_URL}/integrationaccesss/update`,
      ADD: `${NONITMARKETING_API_URL}/integrationaccesss/add`,
    },
    CREDIT_HISTORY_NM: {
      GET_ALL: `${NONITMARKETING_API_URL}/credithistorys/getAll`,
      ADD: `${NONITMARKETING_API_URL}/credithistorys/add`,
    },
    SETTINGS_NM: {
      GET_ALL: `${NONITMARKETING_API_URL}/settings`,
    },
    CANDIDATE_PLATFORM_CREDENTIALS_NM: {
      ADD: `${NONITMARKETING_API_URL}/candidateplatformcredentials/add`,
      GET_ALL: `${NONITMARKETING_API_URL}/candidateplatformcredentials/getAll`,
      UPDATE: `${NONITMARKETING_API_URL}/candidateplatformcredentials/update`,
    },
  };
};

// export const ENDPOINTS = {
//   AUTH: {
//     LOGIN: `${MAIN_API_URL}/users/login`,
//     LOGOUT: `${MAIN_API_URL}/users/logout`,
//     VERIFY_PASSWORD: `${MAIN_API_URL}/users/verifyPassword`,
//   },
//   WF_NOTIFICATIONS: {
//     GET_ALL: `${WORKFORCE_API_URL}/notifications/getAll`,
//     UPDATE: `${WORKFORCE_API_URL}/notifications/update`,
//     GET_TOTAL_COUNT: `${WORKFORCE_API_URL}/notifications/getTotalCount`,
//   },
//   WF_AUTHENTICATION: {
//     VERIFY_TEMP_TOKEN: `${WORKFORCE_API_URL}/authenticate-temp-token`,
//     VERIFY_TEMP_LOGIN: `${WORKFORCE_API_URL}/verify-temp-access`,
//   },
//   MASTER_TEMPLATES: {
//     GET_BY_UIID: `${MAIN_API_URL}/templates/get`,
//   },
//   WF_EMAILS: {
//     SEND: `${WORKFORCE_API_URL}/gmail/sendMail`,
//   },
//   USERS: {
//     GET_ALL: `${MAIN_API_URL}/users/getAll`,
//     ADD: `${MAIN_API_URL}/users/add`,
//     UPDATE: `${MAIN_API_URL}/users/update`,
//     GET: `${MAIN_API_URL}/users/get`,
//     GET_TOTAL_COUNT: `${MAIN_API_URL}/users/getTotalCount`,
//     BS_GET_USERREF: `${BENCHSALES_API_URL}/userrefs/getAll`,
//   },

//   COUNTER: {
//     GETID: `${WORKFORCE_API_URL}/counters/get`,
//   },
//   EMPLOYEES: {
//     GET_ALL: `${WORKFORCE_API_URL}/employees/getAll`,
//     GET_BY_UIID: `${WORKFORCE_API_URL}/employees/get`,
//     GET_TOTAL_COUNT: `${WORKFORCE_API_URL}/employees/getTotalCount`,
//     ADD_NEW: `${WORKFORCE_API_URL}/employees/add`,
//     UPDATE: `${WORKFORCE_API_URL}/employees/update`,
//     BULKUPDATE: `${WORKFORCE_API_URL}/employees/bulkUpdate`,
//     GET_ALL_DATA: `${WORKFORCE_API_URL}/employees/GetAllData`,
//   },
//   ONBOARDINGS: {
//     GET_ALL: `${WORKFORCE_API_URL}/onboardings/getAll`,
//     GET_BY_UIID: `${WORKFORCE_API_URL}/onboardings/get`,
//     GET_TOTAL_COUNT: `${WORKFORCE_API_URL}/onboardings/getTotalCount`,
//     ADD_NEW: `${WORKFORCE_API_URL}/onboardings/add`,
//     UPDATE: `${WORKFORCE_API_URL}/onboardings/update`,
//     BULKUPDATE: `${WORKFORCE_API_URL}/onboardings/bulkUpdate`,
//   },
//   FUNDING_DASHBOARD: {
//     FILE_PARSE: `${WORKFORCE_API_URL}/documents/file-parse`,
//   },
//   WF_REPORTS: {
//     ADD: `${WORKFORCE_API_URL}/reports/add`,
//     GET: `${WORKFORCE_API_URL}/reports/get`,
//     GET_ALL: `${WORKFORCE_API_URL}/reports/getAll`,
//     GET_TOTAL_COUNT: `${WORKFORCE_API_URL}/reports/getTotalCount`,
//   },
//   CHECKLISTS: {
//     GET_ALL: `${WORKFORCE_API_URL}/checklists/getAll`,
//     GET_BY_UIID: `${WORKFORCE_API_URL}/checklists/get`,
//     GET_TOTAL_COUNT: `${WORKFORCE_API_URL}/checklists/getTotalCount`,
//     ADD_NEW: `${WORKFORCE_API_URL}/checklists/add`,
//     UPDATE: `${WORKFORCE_API_URL}/checklists/update`,
//     BULKUPDATE: `${WORKFORCE_API_URL}/checklists/bulkUpdate`,
//   },
//   PDFTEMPLATES: {
//     GET_ALL: `${WORKFORCE_API_URL}/pdftemplates/getAll`,
//     GET_BY_UIID: `${WORKFORCE_API_URL}/pdftemplates/get`,
//     GET_TOTAL_COUNT: `${WORKFORCE_API_URL}/pdftemplates/getTotalCount`,
//     ADD_NEW: `${WORKFORCE_API_URL}/pdftemplates/add`,
//     UPDATE: `${WORKFORCE_API_URL}/pdftemplates/update`,
//     BULKUPDATE: `${WORKFORCE_API_URL}/pdftemplates/bulkUpdate`,
//   },
//   CLIENTS: {
//     GET_ALL: `${WORKFORCE_API_URL}/clients/getAll`,
//     GET_BY_UIID: `${WORKFORCE_API_URL}/clients/get`,
//     GET_TOTAL_COUNT: `${WORKFORCE_API_URL}/clients/getTotalCount`,
//     ADD_NEW: `${WORKFORCE_API_URL}/clients/add`,
//     UPDATE: `${WORKFORCE_API_URL}/clients/update`,
//     ADD_CONTACT: `${WORKFORCE_API_URL}/contacts/add`,
//     UPDATE_CONTACT: `${WORKFORCE_API_URL}/contacts/update`,
//   },
//   TIMESHEETS: {
//     GET_ALL: `${WORKFORCE_API_URL}/timesheets/getAll`,
//     GET_BY_UIID: `${WORKFORCE_API_URL}/timesheets/get`,
//     GET_TOTAL_COUNT: `${WORKFORCE_API_URL}/timesheets/getTotalCount`,
//     ADD_NEW: `${WORKFORCE_API_URL}/timesheets/add`,
//     UPDATE: `${WORKFORCE_API_URL}/timesheets/update`,
//   },
//   PLACEMENTS: {
//     GET_ALL: `${WORKFORCE_API_URL}/placements/getAll`,
//     GET_BY_UIID: `${WORKFORCE_API_URL}/placements/get`,
//     GET_TOTAL_COUNT: `${WORKFORCE_API_URL}/placements/getTotalCount`,
//     ADD_NEW: `${WORKFORCE_API_URL}/placements/add`,
//     UPDATE: `${WORKFORCE_API_URL}/placements/update`,
//   },
//   VENDORS: {
//     GET_ALL: `${WORKFORCE_API_URL}/vendors/getAll`,
//     GET_BY_UIID: `${WORKFORCE_API_URL}/vendors/get`,
//     GET_TOTAL_COUNT: `${WORKFORCE_API_URL}/vendors/getTotalCount`,
//     ADD_NEW: `${WORKFORCE_API_URL}/vendors/add`,
//     UPDATE: `${WORKFORCE_API_URL}/vendors/update`,
//     ADD_CONTACT: `${WORKFORCE_API_URL}/contacts/add`,
//     UPDATE_CONTACT: `${WORKFORCE_API_URL}/contacts/update`,
//   },
//   WORK_AUTHS: {
//     GET_ALL: `${WORKFORCE_API_URL}/workauths/getAll`,
//     ADD_NEW: `${WORKFORCE_API_URL}/workauths/add`,
//     UPDATE: `${WORKFORCE_API_URL}/workauths/update`,
//   },
//   // PLACEMENTS: {
//   //   GET_ALL: `${WORKFORCE_API_URL}/placements/getAll`,
//   //   GET_BY_UIID: `${WORKFORCE_API_URL}/placements/get`,
//   //   ADD_NEW: `${WORKFORCE_API_URL}/placements/add`,
//   //   UPDATE: `${WORKFORCE_API_URL}/placements/update`,
//   // },
//   IMMIGRATION: {
//     GET_BY_UIID: `${WORKFORCE_API_URL}/immigrations/get`,
//     ADD_NEW: `${WORKFORCE_API_URL}/immigrations/add`,
//     UPDATE: `${WORKFORCE_API_URL}/immigrations/update`,
//   },
//   LCA: {
//     GET_BY_UIID: `${WORKFORCE_API_URL}/lcas/get`,
//     GET_ALL: `${WORKFORCE_API_URL}/lcas/getAll`,
//     ADD_NEW: `${WORKFORCE_API_URL}/lcas/add`,
//     UPDATE: `${WORKFORCE_API_URL}/lcas/update`,
//   },
//   H1B: {
//     GET_BY_UIID: `${WORKFORCE_API_URL}/h1bs/get`,
//     GET_ALL: `${WORKFORCE_API_URL}/h1bs/getAll`,
//     ADD_NEW: `${WORKFORCE_API_URL}/h1bs/add`,
//     UPDATE: `${WORKFORCE_API_URL}/h1bs/update`,
//   },
//   VISA: {
//     GET_BY_UIID: `${WORKFORCE_API_URL}/visas/get`,
//     GET_ALL: `${WORKFORCE_API_URL}/visas/getAll`,
//     ADD_NEW: `${WORKFORCE_API_URL}/visas/add`,
//     UPDATE: `${WORKFORCE_API_URL}/visas/update`,
//   },

//   JOBNADVS: {
//     GET_BY_UIID: `${WORKFORCE_API_URL}/jobnadvs/get`,
//     GET_ALL: `${WORKFORCE_API_URL}/jobnadvs/getAll`,
//     ADD_NEW: `${WORKFORCE_API_URL}/jobnadvs/add`,
//     UPDATE: `${WORKFORCE_API_URL}/jobnadvs/update`,
//   },
//   DOCUMENT: {
//     GET_ALL: `${WORKFORCE_API_URL}/documents/getAll`,
//     ADD_TAXFORM: `${WORKFORCE_API_URL}/emptaxforms/add`,
//     GET_ALL_TAXFORM: `${WORKFORCE_API_URL}/emptaxforms/getAll`,
//   },
//   UNIVERSAL: {
//     UPLOAD_FILE: `${WORKFORCE_API_URL}`,
//     DOCUMENT_ADD: `${WORKFORCE_API_URL}/documents/add`,
//     GET_S3_LINK: `${WORKFORCE_API_URL}/documents/getSignUrl?coll=Document`,
//   },

//   GET_TOTAL_COUNT: `${WORKFORCE_API_URL}`,
//   GET_TOTAL_COUNT_ATS: `${ATS_API_URL}`,
//   GET_TOTAL_COUNT_MASTER: `${MAIN_API_URL}`,
//   GET_TOTAL_COUNT_BENCHSALES: `${BENCHSALES_API_URL}`,
//   ACCOUNT_PAYBLES: {
//     GET_ALL: `${WORKFORCE_API_URL}/accountpayables/getAll`,
//     GET_BY_UIID: `${WORKFORCE_API_URL}/accountpayables/get`,
//     ADD_NEW: `${WORKFORCE_API_URL}/accountpayables/add`,
//     UPDATE: `${WORKFORCE_API_URL}/accountpayables/update`,
//   },
//   INVOICES: {
//     GET_ALL: `${WORKFORCE_API_URL}/invoices/getAll`,
//     GET_BY_UIID: `${WORKFORCE_API_URL}/invoices/get`,
//     ADD_NEW: `${WORKFORCE_API_URL}/invoices/add`,
//     UPDATE: `${WORKFORCE_API_URL}/invoices/update`,
//     BULKUPDATE: `${WORKFORCE_API_URL}/invoices/bulkUpdate`,
//   },

//   INCENTIVES: {
//     GET_ALL: `${WORKFORCE_API_URL}/incentives/getAll`,
//     GET_BY_UIID: `${WORKFORCE_API_URL}/incentives/get`,
//     ADD_NEW: `${WORKFORCE_API_URL}/incentives/add`,
//     UPDATE: `${WORKFORCE_API_URL}/incentives/update`,
//     DELETE: `${WORKFORCE_API_URL}/incentives/delete`,
//     GET_TOTAL_COUNT: `${WORKFORCE_API_URL}/incentives/getTotalCount`,
//     GET_SHEET: `${WORKFORCE_API_URL}/incentives/sheet`,
//   },
//   INCENTIVE_SETTINGS: {
//     GET_BY_KEY: `${WORKFORCE_API_URL}/incentivesettings/get`,
//     ADD: `${WORKFORCE_API_URL}/incentivesettings/add`,
//     UPDATE: `${WORKFORCE_API_URL}/incentivesettings/update`,
//   },

//   PAYROLL_SALARYY_PROFILE: {
//     GET_ALL: `${WORKFORCE_API_URL}/salaryprofiles/getAll`,
//     GET_BY_UIID: `${WORKFORCE_API_URL}/salaryprofiles/get`,
//     ADD_NEW: `${WORKFORCE_API_URL}/salaryprofiles/add`,
//     UPDATE: `${WORKFORCE_API_URL}/salaryprofiles/update`,
//   },
//   EMPLOYEE_PAY_CONFIGURATION: {
//     GET_ALL: `${WORKFORCE_API_URL}/emppayconfigs/getAll`,
//     GET_BY_UIID: `${WORKFORCE_API_URL}/emppayconfigs/get`,
//     ADD_NEW: `${WORKFORCE_API_URL}/emppayconfigs/add`,
//     UPDATE: `${WORKFORCE_API_URL}/emppayconfigs/update`,
//   },
//   PAYROLL: {
//     GET_ALL: `${WORKFORCE_API_URL}/payrolls/getAll`,
//     GET_BY_UIID: `${WORKFORCE_API_URL}/payrolls/get`,
//     ADD_NEW: `${WORKFORCE_API_URL}/payrolls/add`,
//     UPDATE: `${WORKFORCE_API_URL}/payrolls/update`,
//     GET_TOTAL_COUNT: `${WORKFORCE_API_URL}/payrolls/getTotalCount`,
//   },
//   EMPLOYEE_DEDUCTIONS: {
//     GET_ALL: `${WORKFORCE_API_URL}/empdeductions/getAll`,
//     GET_BY_UIID: `${WORKFORCE_API_URL}/empdeductions/get`,
//     ADD_NEW: `${WORKFORCE_API_URL}/empdeductions/add`,
//     UPDATE: `${WORKFORCE_API_URL}/empdeductions/update`,
//   },
//   EMPLOYEE_OTHER_PAYMENTS: {
//     GET_ALL: `${WORKFORCE_API_URL}/empotherpays/getAll`,
//     GET_BY_UIID: `${WORKFORCE_API_URL}/empotherpays/get`,
//     ADD_NEW: `${WORKFORCE_API_URL}/empotherpays/add`,
//     UPDATE: `${WORKFORCE_API_URL}/empotherpays/update`,
//   },
//   RECONCILIATION: {
//     GET_ALL: `${WORKFORCE_API_URL}/reconciliations/getAll`,
//     GET_BY_UIID: `${WORKFORCE_API_URL}/reconciliations/get`,
//     ADD_NEW: `${WORKFORCE_API_URL}/reconciliations/add`,
//     UPDATE: `${WORKFORCE_API_URL}/reconciliations/parse-xlsx`,
//     GET_TOTAL_COUNT: `${WORKFORCE_API_URL}/reconciliations/getTotalCount`,
//   },
//   EMPLOYEE_BONUS: {
//     GET_ALL: `${WORKFORCE_API_URL}/empbonuspays/getAll`,
//     GET_BY_UIID: `${WORKFORCE_API_URL}/empbonuspays/get`,
//     ADD_NEW: `${WORKFORCE_API_URL}/empbonuspays/add`,
//     UPDATE: `${WORKFORCE_API_URL}/empbonuspays/update`,
//     GET_TOTAL_COUNT: `${WORKFORCE_API_URL}/empbonuspays/getTotalCount`,
//   },
//   EMPLOYEE_ADJUSTMENTS: {
//     GET_ALL: `${WORKFORCE_API_URL}/empadjustments/getAll`,
//     GET_TOTAL_COUNT: `${WORKFORCE_API_URL}/empadjustments/getTotalCount`,
//   },
//   MISC: {
//     RUN_SERVER_TASKS: `${WORKFORCE_API_URL}/server-tasks`,
//   },
//   INCOMING_PLACEMENTS: {
//     GET_ALL: `${WORKFORCE_API_URL}/incomingplacements/getAll`,
//     GET_TOTAL_COUNT: `${WORKFORCE_API_URL}/incomingplacements/getTotalCount`,
//     PUSH: `${WORKFORCE_API_URL}/placements/incoming`,
//     APPROVE: `${WORKFORCE_API_URL}/placements/incoming`,
//     UPDATE: `${WORKFORCE_API_URL}/incomingplacements/update`,
//   },
//   COMPANIES: {
//     GET_ALL: `${ATS_API_URL}/companys/getAll`,
//     GET_BY_UIID: `${ATS_API_URL}/companys/get`,
//     ADD_NEW: `${ATS_API_URL}/companys/add`,
//     DELETE: `${ATS_API_URL}/companys/delete`,
//     UPDATE: `${ATS_API_URL}/companys/update`,
//     MERGE: `${ATS_API_URL}/companys/mergeCompany`,
//   },
//   SYSTEMSTATS: {
//     GET_ALL: `${ATS_API_URL}/systemstats/getAll`,
//   },
//   PROSPECTS: {
//     GET_ALL: `${ATS_API_URL}/prospects/getAll`,
//     GET: `${ATS_API_URL}/prospects/get`,
//     BULK_UPDATE: `${ATS_API_URL}/prospects/bulkUpdate`,
//     UPDATE: `${ATS_API_URL}/prospects/update`,
//   },
//   CITIES: {
//     GET_ALL: `${MAIN_API_URL}/cities/getAll`,
//     DELETE: `${MAIN_API_URL}/cities/delete`,
//   },
//   COUNTRIES: {
//     GET_ALL: `${MAIN_API_URL}/countries/getAll`,
//   },
//   STATES: {
//     ADD_NEW_LOCATION: `${MAIN_API_URL}/states/locations/add`,
//     GET_ALL: `${MAIN_API_URL}/states/getAll`,
//     DELETE: `${MAIN_API_URL}/states/delete`,
//   },

//   // STATES: {
//   //   ADD_NEW_LOCATION: `${MAIN_API_URL}/states/locations/add`,
//   //   GET_ALL: `${MAIN_API_URL}/states/getAll`,
//   //   DELETE: `${MAIN_API_URL}/states/delete`,
//   // },

//   //here  first defined for ats , now we are hanging to benchsales api url
//   JOBS: {
//     GET_ALL: `${ATS_API_URL}/jobs/getAll`,
//     GET: `${ATS_API_URL}/jobs/get`,
//     ADD: `${ATS_API_URL}/jobs/add`,
//     DELETE: `${ATS_API_URL}/jobs/delete`,
//     UPDATE: `${ATS_API_URL}/jobs/update`,
//   },
//   TEAMLEAD: {
//     GET_ALL: `${ATS_API_URL}/companys/getAll`,
//   },
//   JOBPOSTINGS: {
//     ADD: `${ATS_API_URL}/jobpostings/add`,
//     GET_ALL: `${ATS_API_URL}/jobpostings/getAll`,
//     GET: `${ATS_API_URL}/jobpostings/get`,
//     UPDATE: `${ATS_API_URL}/jobpostings/update`,
//     //GET_QUESTIONS:`${ATS_API_URL}/jobpostquestions/getAll`
//   },
//   SETTINGS: {
//     GET_ALL: `${ATS_API_URL}/settings/getAll`,
//     ADD: `${ATS_API_URL}/settings/add`,
//     UPDATE: `${ATS_API_URL}/settings/update`,
//   },
//   EMAILTEMPLATE: {
//     GET_ALL: `${ATS_API_URL}/templates/getAll`,
//     ADD: `${ATS_API_URL}/templates/add`,
//     DELETE: `${ATS_API_URL}/templates/delete`,
//     GET: `${ATS_API_URL}/templates/get`,
//     UPDATE: `${ATS_API_URL}/templates/update`,
//   },

//   BDMJOBS: {
//     GET_ALL: `${ATS_API_URL}/submissions/getAll`,
//   },
//   NOTES: {
//     ADD: `${ATS_API_URL}/notes/add`,
//     GET_ALL: `${ATS_API_URL}/notes/getAll`,
//     DELETE: `${ATS_API_URL}/notes/delete`,
//   },
//   INTEGRATIONS: {
//     GET: `${ATS_API_URL}/integrations/get`,
//     ADD: `${ATS_API_URL}/integrations/add`,
//     UPDATE: `${ATS_API_URL}/integrations/update`,
//     POST: `${ATS_API_URL}/integration/internal-db-resume-download`,
//     GET_ALL: `${ATS_API_URL}/integrations/getAll`,
//     DELETE: `${ATS_API_URL}/integrations/delete`,
//   },
//   INTEGRATION_ACCESS: {
//     GET: `${ATS_API_URL}/integrationaccesss/get`,
//     GET_ALL: `${ATS_API_URL}/integrationaccesss/getAll`,
//     UPDATE: `${ATS_API_URL}/integrationaccesss/update`,
//     ADD: `${ATS_API_URL}/integrationaccesss/add`,
//   },
//   RECRUITEMENT: {
//     GET_ALL: `${ATS_API_URL}/candidates/getAll`,
//   },

//   ROLES: {
//     GET_ALL: `${MAIN_API_URL}/roles/getAll`,
//     ADD: `${MAIN_API_URL}/roles/add`,
//     DELETE: `${MAIN_API_URL}/roles/delete`,
//     UPDATE: `${MAIN_API_URL}/roles/update`,
//     GET: `${MAIN_API_URL}/roles/get`,
//   },

//   SHUFFLE: {
//     ADD: `${ATS_API_URL}/shuffles/add`,
//     GET_ALL: `${ATS_API_URL}/shuffles/getAll`,
//   },
//   ORGANIZATIONS: {
//     UPDATE: `${MAIN_API_URL}/organizations/update`,
//     GET: `${MAIN_API_URL}/organizations/get`,
//     UPLOAD: `${MAIN_API_URL}/organizations/upload`,
//     GET_IMAGE_S3_LINK: `${MAIN_API_URL}/organizations/getSignUrl?coll=Organization`,
//   },
//   SUBMISSOINS: {
//     UPDATE: `${ATS_API_URL}/submissions/update`,
//     GET_ALL: `${ATS_API_URL}/submissions/getAll`,
//     POST: `${ATS_API_URL}/submissions/add`,
//     PUSH_TO_WORKFORCE: `${ATS_API_URL}/submissions/push-to-workforce`,
//   },
//   SEARCH: {
//     MONSTER_SEARCH: `${ATS_API_URL}/integration/monster-search`,
//     MONSTER_RESUME_IMPORT: `${ATS_API_URL}/integration/monster-resume-import`,
//     MONSTER_RESUMES_IMPORT: `${ATS_API_URL}/integration/monster-resumes-import`,
//     CAREER_BUILDER_SEARCH: `${ATS_API_URL}/integration/careerbuilder-search`,
//     CAREER_BUILDER_RESUME_IMPORT: `${ATS_API_URL}/integration/careerbuilder-resume-import`,
//     CAREER_BUILDER_RESUMES_IMPORT: `${ATS_API_URL}/integration/careerbuilder-resumes-import`,
//     INTERNAL_DB: `${ATS_API_URL}/integration/internaldb-search`,
//   },
//   INSTANTLY: {
//     GET_CAMPAIGN: `${ATS_API_URL}/integration/instantly-get-campaign`,
//     GETALL_CAMPAIGN: `${ATS_API_URL}/integration/instanly-getall-campaign`,
//     GET_BULK_ANALYST: `${ATS_API_URL}/integration/instantly-getbulk-analyst`,
//     ADD_CAMPAIGN: `${ATS_API_URL}/integration/instantly-create-campaign`,
//     PAUSE_CAMPAIGN: `${ATS_API_URL}/integration/instantly-pause-campaign`,
//     START_CAMPAIGN: `${ATS_API_URL}/integration/instantly-start-campaign`,
//     DELETE_CAMPAIGN: `${ATS_API_URL}/integration/instantly-delete-campaign`,
//     UPDATE_CAMPAIGN: `${ATS_API_URL}/integration/instantly-update-campaign`,
//     DUPLICATE_CAMPAIGN: `${ATS_API_URL}/integration/instantly-duplicate-campaign`,
//   },
//   JOB_BOARDS_HISTORY: {
//     HISTORY: `${ATS_API_URL}/jobboardshistory`,
//     ADD: `${ATS_API_URL}/jobboardshistory`, //for integrated search to add history
//   },
//   // signatures
//   SIGNATURES: {
//     GET: `${ATS_API_URL}/signatures/get`,
//     UPDATE: `${ATS_API_URL}/signatures/update`,
//     GET_ALL: `${ATS_API_URL}/signatures/getAll`,
//     ADD: `${ATS_API_URL}/signatures/add`,
//   },
//   // prospectEmailLogs
//   PROSPECTEMAILLOGS: {
//     GET: `${ATS_API_URL}/prospectemaillogs/get`,
//     UPDATE: `${ATS_API_URL}/prospectemaillogs/update`,
//     GET_ALL: `${ATS_API_URL}/prospectemaillogs/getAll`,
//     ADD: `${ATS_API_URL}/prospectemaillogs/add`,
//   },

//   CANDIDATES: {
//     GET_ALL: `${ATS_API_URL}/candidates/getAll`,
//     ADD: `${ATS_API_URL}/candidates/add`,
//     GET: `${ATS_API_URL}/candidates/get`,
//     UPDATE: `${ATS_API_URL}/candidates/update`,
//     RESUME_URL: `${ATS_API_URL}/candidates/getSignUrl`,
//     RESUME_PARSER: `${ATS_API_URL}/candidates/resume-parser`,
//     BULK_RESUME_PARSER: `${ATS_API_URL}/candidates/bulk-resume-parser`,
//   },

//   JOB_BOARDS_CREDIT_HISTORY: {
//     GET_ALL: `${ATS_API_URL}/jobboardcredithistorys/getAll`,
//     ADD: `${ATS_API_URL}/jobboardcredithistorys/add`,
//   },

//   RESUME_MINING: {
//     GET_ALL: `${ATS_API_URL}/resumeminings/getAll`,
//     ADD: `${ATS_API_URL}/resumeminings/add`,
//     DELETE: `${ATS_API_URL}/resumeminings/delete`,
//     UPDATE: `${ATS_API_URL}/resumeminings/update`,
//   },
//   RESUME_MINING_HISTORY: {
//     GET_ALL: `${ATS_API_URL}/resumemininghistorys/getAll`,
//   },
//   PUSH_DATA_TO_WORKFORCE: {
//     GET: `${ATS_API_URL}/submissions/getAll`,
//   },
//   KULT_FETCH: {
//     GET_ALL: `${ATS_API_URL}/kultfetches/getAll`,
//   },
//   HOTLIST: {
//     GET_ALL: `${ATS_API_URL}/hotlists/getAll`,
//   },
//   TALENT_MATCH: {
//     GET_ALL: `${ATS_API_URL}/talentmatches/getAll`,
//     UPDATE: `${ATS_API_URL}/talentmatches/update`,
//     BULK_UPDATE: `${ATS_API_URL}/talentmatches/bulkUpdate`,
//   },
//   ATS_UNIVERSAL: {
//     UPLOAD_FILE: `${ATS_API_URL}`,
//     DOCUMENT_ADD: `${ATS_API_URL}/documents/add`,
//     GET_S3_LINK: `${ATS_API_URL}/documents/getSignUrl?coll=Document`,
//   },
//   EMAIL: {
//     POST: `${ATS_API_URL}/candidateemaillogs/add`,
//     GET: `${ATS_API_URL}/candidateemaillogs/getTotalCount`,
//     GET_ALL: `${ATS_API_URL}/candidateemaillogs/getAll`,
//     GET_ALL_CAMPAIGNS: `${ATS_API_URL}/emailcampaigns/getAll`,
//   },
//   LOCAL_RESTRICTIONS: {
//     ADD: `${ATS_API_URL}/locationrestrictions/add`,
//     GET_ALL: `${ATS_API_URL}/locationrestrictions/getAll`,
//     DELETE: `${ATS_API_URL}/locationrestrictions/delete`,
//   },
//   REPORTS: {
//     GET_ALL: `${ATS_API_URL}/reports/getAll`,
//   },
//   FAVOURITE_REPORTS: {
//     GET_ALL: `${ATS_API_URL}/favouritereports/getAll`,
//     ADD: `${ATS_API_URL}/favouritereports/add`,
//     DELETE: `${ATS_API_URL}/favouritereports/delete`,
//   },
//   AICALLS: {
//     ADD: `${ATS_API_URL}/aicalls/add`,
//     GET_ALL: `${ATS_API_URL}/aicalls/getAll`,
//     GET_DETAILS: `${ATS_API_URL}/integration/kult-ai-call`,
//     UPDATE: `${ATS_API_URL}/aicalls/update`,
//   },
//   CANDIDATE: {
//     GET_ALL: `${BENCHSALES_API_URL}/candidates/getAll`,
//     GET_BY_ID: `${BENCHSALES_API_URL}/candidates/getById`,
//     ADD: `${BENCHSALES_API_URL}/candidates/add`,
//     GET: `${BENCHSALES_API_URL}/candidates/get`,
//     UPDATE: `${BENCHSALES_API_URL}/candidates/update`,
//     GET_TOTAL_COUNT_CANDIDATE: `${BENCHSALES_API_URL}/candidates/getTotalCount`,
//     UPLOAD: `${BENCHSALES_API_URL}/candidates/upload`,
//     ANALYZE: `${BENCHSALES_API_URL}/candidates/analyze`,
//     RESUME_PARSER: `${BENCHSALES_API_URL}/candidates/resume-parser`,
//     GET_TOTAL_USER_COUNT: `${BENCHSALES_API_URL}/candidates/getTotalUsersCount`,
//     GET_DOC: `${BENCHSALES_API_URL}/candidates/getSignUrl`,
//     DELETE: `${BENCHSALES_API_URL}/candidates/delete`,
//   },
//   JOB: {
//     GET_ALL: `${BENCHSALES_API_URL}/jobs/getAll`,
//     GET_TOTAL_COUNT: `${BENCHSALES_API_URL}/jobs/getTotalUsersCount`,
//     ADD: `${BENCHSALES_API_URL}/jobs/add`,
//     UPDATE: `${BENCHSALES_API_URL}/jobs/update`,
//   },
//   CONTACTS: {
//     ADD: `${BENCHSALES_API_URL}/contacts/add`,
//     VERIFY: `${BENCHSALES_API_URL}/contacts/verify`,
//     GET_ALL: `${BENCHSALES_API_URL}/contacts/getAll`,
//     GET: `${BENCHSALES_API_URL}/contacts/get`,
//     UPDATE: `${BENCHSALES_API_URL}/contacts/update`,
//     DELETE: `${BENCHSALES_API_URL}/contacts/delete`,
//   },
//   SUBMISSION: {
//     ADD: `${BENCHSALES_API_URL}/submissions/add`,
//     GET_ALL: `${BENCHSALES_API_URL}/submissions/getAll`,
//     GET_TOTAL_COUNT_SUBMISSION: `${BENCHSALES_API_URL}/submissions/getTotalCount`,
//   },
//   USER_REFS: {
//     ATS_USER_GET_ALL: `${ATS_API_URL}/userrefs/getAll`,
//     ATS_USER_COUNT: `${ATS_API_URL}/userrefs/count`,
//     ATS_USER_HIERARCHY: `${ATS_API_URL}/userrefs/getRepotingHierarchy`,
//     WF_USER_GET_ALL: `${WORKFORCE_API_URL}/userrefs/getAll`,
//     WF_USER_COUNT: `${WORKFORCE_API_URL}/userrefs/count`,
//     ATS_GET_LEADS_MANAGERS: `${ATS_API_URL}/userrefs/getManager`,
//   },
//   BUILD_VERSION: {
//     ADD: `${ATS_API_URL}/buildversions/add`,
//     GET_ALL: `${ATS_API_URL}/buildversions/getAll`,
//   },
//   ENGAGEMENT_STATUS: {
//     ADD: `${ATS_API_URL}/engagementstatuss/add`,
//     GET_ALL: `${ATS_API_URL}/engagementstatuss/getAll`,
//   },
//   INTERVIEW: {
//     ADD: `${BENCHSALES_API_URL}/interviews/add`,
//     GET_ALL: `${BENCHSALES_API_URL}/interviews/getAll`,
//     GET_TOTAL_COUNT_INTERVIEWS: `${BENCHSALES_API_URL}/interviews/getTotalCount`,
//     GET_TOTAL_MAIN_COUNT: `${BENCHSALES_API_URL}/interviews/getTotalMainCount`,
//   },
//   BS_REPORTS: {
//     GET_ALL: `${BENCHSALES_API_URL}/reports/getAll`,
//   },
//   BS_TEMPLATES: {
//     ADD: `${BENCHSALES_API_URL}/templates/add`,
//     GET_ALL: `${BENCHSALES_API_URL}/templates/getAll`,
//     DELETE: `${BENCHSALES_API_URL}/templates/delete`,
//     UPDATE: `${BENCHSALES_API_URL}/templates/update`,
//   },
//   BS_CONTACTS: {
//     POST: `${BENCHSALES_API_URL}/apollo/peoples`,
//     POST_EMAIL: `${BENCHSALES_API_URL}/apollo/profiles?getEmail=true`,
//     AUTH: `${BENCHSALES_API_URL}/apollo/auth`,
//   },
//   BS_AUTH: {
//     UPDATE: `${BENCHSALES_API_URL}/authtokens/updateByEmail`,
//   },
//   BS_EMAILLOGS: {
//     ADD: `${BENCHSALES_API_URL}/emaillogs/add`,
//   },
//   BS_GMAIL: {
//     GMAIL_AUTH: `${BENCHSALES_API_URL}/gmail/auth`,
//     GET_GMAIL: `${BENCHSALES_API_URL}/gmail/accounts`,
//   },
//   BS_OUTLOOK: {
//     OUTLOOK_AUTH: `${BENCHSALES_API_URL}/outlook/auth`,
//     GET_OUTLOOK: `${BENCHSALES_API_URL}/outlook/accounts`,
//   },
//   BS_MAIL_ACCOUNT: {
//     ASSIGN_ACCESS: `${BENCHSALES_API_URL}/assign-access`,
//   },
//   EMAILACCOUNT: {
//     GET_ALL: `${BENCHSALES_API_URL}/emailaccounts/getAll`,
//     GET_TOTAL_COUNT: `${BENCHSALES_API_URL}/emailaccounts/getTotalUsersCount`,
//     UPDATE: `${BENCHSALES_API_URL}/emailaccounts/updateAccessStatus`,
//     DELETE: `${BENCHSALES_API_URL}/emailaccounts/delete`,
//   },

//   PLACEMENT: {
//     ADD: `${BENCHSALES_API_URL}/placements/add`,
//     GET_ALL: `${BENCHSALES_API_URL}/placements/getAll`,
//     GET_TOTAL_COUNT_PLACEMENTS: `${BENCHSALES_API_URL}/placements/getTotalCount`,
//   },
//   USEREF: {
//     GET_ALL: `${BENCHSALES_API_URL}/userrefs/getAll`,
//     GET_TOTAL_COUNT: `${BENCHSALES_API_URL}/userrefs/count`,
//   },
//   CANDIDATEVERSION: {
//     GET_ALL: `${BENCHSALES_API_URL}/candidateversions/getAll`,
//     DELETE: `${BENCHSALES_API_URL}/candidateversions/delete`,
//   },
//   OPTIMISERESUME: {
//     GET_ALL: `${BENCHSALES_API_URL}/algorithm/kult`,
//   },
//   AIDRAFT: {
//     GET_ALL: `${BENCHSALES_API_URL}/content/draft`,
//   },

//   BS_COMPANIES: {
//     GET_ALL: `${BENCHSALES_API_URL}/companys/getAll`,
//     ADD: `${BENCHSALES_API_URL}/companys/add`,
//   },
//   BS_INTEGRATION_ACCESS: {
//     GET_ALL: `${BENCHSALES_API_URL}/integrationaccesses/getAll`,
//     ADD: `${BENCHSALES_API_URL}/integrationaccess/add`,
//   },
//   LEAD_COMPANY: {
//     GET_ALL: `${ATS_API_URL}/leadcompanys/getAll`,
//     GET: `${ATS_API_URL}/leadcompanys/get`,
//     AGREEMENT_URL: `${ATS_API_URL}/leadcompanys/getSignUrl`,
//     ADD: `${ATS_API_URL}/leadcompanys/add`,
//     UPDATE: `${ATS_API_URL}/leadcompanys/update`,
//     DELETE: `${ATS_API_URL}/leadcompanys/delete`,
//   },
//   LEAD_JOB: {
//     GET_ALL: `${ATS_API_URL}/leadjobs/getAll`,
//     ADD: `${ATS_API_URL}/leadjobs/add`,
//     UPDATE: `${ATS_API_URL}/leadjobs/update`,
//   },
//   LEAD_CONTACT: {
//     GET_ALL: `${ATS_API_URL}/leadcontacts/getAll`,
//     ADD: `${ATS_API_URL}/leadcontacts/add`,
//     UPDATE: `${ATS_API_URL}/leadcontacts/update`,
//   },
//   BENCHSALES_HOTLIST: {
//     GET_ALL: `${BENCHSALES_API_URL}/hotlists/getAll`,
//     ADD: `${BENCHSALES_API_URL}/hotlists/add`,
//     UPDATE: `${BENCHSALES_API_URL}/hotlists/update`,
//     DELETE: `${BENCHSALES_API_URL}/hotlists/delete`,
//   },
//   INTEGRATION_BS: {
//     GET_ALL: `${BENCHSALES_API_URL}/integrationbss/getAll`,
//     ADD: `${BENCHSALES_API_URL}/integrationbss/add`,
//     UPDATE: `${BENCHSALES_API_URL}/integrationbss/update`,
//     DELETE: `${BENCHSALES_API_URL}/integrationbss/delete`,
//   },
//   INTEGRATION_ACCESS_BS: {
//     GET: `${BENCHSALES_API_URL}/integrationaccesss/get`,
//     GET_ALL: `${BENCHSALES_API_URL}/integrationaccesss/getAll`,
//     UPDATE: `${BENCHSALES_API_URL}/integrationaccesss/update`,
//     ADD: `${BENCHSALES_API_URL}/integrationaccesss/add`,
//   },
//   CREDIT_HISTORY_BS: {
//     GET_ALL: `${BENCHSALES_API_URL}/credithistorys/getAll`,
//     ADD: `${BENCHSALES_API_URL}/credithistorys/add`,
//   },
//   SETTINGS_BS: {
//     GET_ALL: `${BENCHSALES_API_URL}/settings`,
//   },
//   CANDIDATE_PLATFORM_CREDENTIALS: {
//     ADD: `${BENCHSALES_API_URL}/candidateplatformcredentials/add`,
//     GET_ALL: `${BENCHSALES_API_URL}/candidateplatformcredentials/getAll`,
//     UPDATE: `${BENCHSALES_API_URL}/candidateplatformcredentials/update`,
//   },
//   TICKET: {
//     ADD: `${ADMIN_API_URL}/tickets/add`,
//   },
//   PUBLIC: {
//     GET_ORG_BASE_URL: `${MAIN_API_URL}/view/organizations`,
//   },
//   IP: {
//     GET_ALL: `${MAIN_API_URL}/ipwhitelists/getAll`,
//     ADD: `${MAIN_API_URL}/ipwhitelists/add`,
//     UPDATE: `${MAIN_API_URL}/ipwhitelists/update`,
//     DELETE: `${MAIN_API_URL}/ipwhitelists/delete`,
//   },
// };

// export const ENDPOINTS = new Proxy({}, {
//   get(_, section) {
//     return getEndPoints()[section]; // evaluates fresh on every access
//   }
// });
export const ENDPOINTS = {
  AUTH: {
    LOGIN: `${MAIN_API_URL}/users/login`,
    LOGOUT: `${MAIN_API_URL}/users/logout`,
    VERIFY_PASSWORD: `${MAIN_API_URL}/users/verifyPassword`,
  },
  WF_NOTIFICATIONS: {
    GET_ALL: `${WORKFORCE_API_URL}/notifications/getAll`,
    UPDATE: `${WORKFORCE_API_URL}/notifications/update`,
    GET_TOTAL_COUNT: `${WORKFORCE_API_URL}/notifications/getTotalCount`,
  },
  WF_AUTHENTICATION: {
    VERIFY_TEMP_TOKEN: `${WORKFORCE_API_URL}/authenticate-temp-token`,
    VERIFY_TEMP_LOGIN: `${WORKFORCE_API_URL}/verify-temp-access`,
  },
  MASTER_TEMPLATES: {
    GET_BY_UIID: `${MAIN_API_URL}/templates/get`,
  },
  WF_EMAILS: {
    SEND: `${WORKFORCE_API_URL}/gmail/sendMail`,
  },
  USERS: {
    GET_ALL: `${MAIN_API_URL}/users/getAll`,
    ADD: `${MAIN_API_URL}/users/add`,
    UPDATE: `${MAIN_API_URL}/users/update`,
    GET: `${MAIN_API_URL}/users/get`,
    GET_TOTAL_COUNT: `${MAIN_API_URL}/users/getTotalCount`,
    BS_GET_USERREF: `${BENCHSALES_API_URL}/userrefs/getAll`,
    NM_GET_USERREF: `${NONITMARKETING_API_URL}/userrefs/getAll`,
  },

  COUNTER: {
    GETID: `${WORKFORCE_API_URL}/counters/get`,
  },
  EMPLOYEES: {
    GET_ALL: `${WORKFORCE_API_URL}/employees/getAll`,
    GET_BY_UIID: `${WORKFORCE_API_URL}/employees/get`,
    GET_TOTAL_COUNT: `${WORKFORCE_API_URL}/employees/getTotalCount`,
    ADD_NEW: `${WORKFORCE_API_URL}/employees/add`,
    UPDATE: `${WORKFORCE_API_URL}/employees/update`,
    BULKUPDATE: `${WORKFORCE_API_URL}/employees/bulkUpdate`,
    GET_ALL_DATA: `${WORKFORCE_API_URL}/employees/GetAllData`,
  },
  WF_JOURNAL_ENTRY: {
    GET_ALL: `${WORKFORCE_API_URL}/journalentrys/getAll`,
    GET_BY_UIID: `${WORKFORCE_API_URL}/journalentrys/get`,
    ADD_NEW: `${WORKFORCE_API_URL}/journalentrys/add`,
    UPDATE: `${WORKFORCE_API_URL}/journalentrys/update`,
    GET_TOTAL_COUNT: `${WORKFORCE_API_URL}/journalentrys/getTotalCount`,
  },
  WF_OFFTRX_MESSAGES: {
    GET_ALL: `${WORKFORCE_API_URL}/bankingmessages/getAll`,
    GET_BY_UIID: `${WORKFORCE_API_URL}/bankingmessages/get`,
    ADD_NEW: `${WORKFORCE_API_URL}/bankingmessages/add`,
    UPDATE: `${WORKFORCE_API_URL}/bankingmessages/update`,
    GET_TOTAL_COUNT: `${WORKFORCE_API_URL}/bankingmessages/getTotalCount`,
  },
  ONBOARDINGS: {
    GET_ALL: `${WORKFORCE_API_URL}/onboardings/getAll`,
    GET_BY_UIID: `${WORKFORCE_API_URL}/onboardings/get`,
    GET_TOTAL_COUNT: `${WORKFORCE_API_URL}/onboardings/getTotalCount`,
    ADD_NEW: `${WORKFORCE_API_URL}/onboardings/add`,
    UPDATE: `${WORKFORCE_API_URL}/onboardings/update`,
    BULKUPDATE: `${WORKFORCE_API_URL}/onboardings/bulkUpdate`,
  },
  FUNDING_DASHBOARD: {
    FILE_PARSE: `${WORKFORCE_API_URL}/documents/file-parse`,
  },
  WF_REPORTS: {
    ADD: `${WORKFORCE_API_URL}/reports/add`,
    GET: `${WORKFORCE_API_URL}/reports/get`,
    GET_ALL: `${WORKFORCE_API_URL}/reports/getAll`,
    GET_TOTAL_COUNT: `${WORKFORCE_API_URL}/reports/getTotalCount`,
  },
  CHECKLISTS: {
    GET_ALL: `${WORKFORCE_API_URL}/checklists/getAll`,
    GET_BY_UIID: `${WORKFORCE_API_URL}/checklists/get`,
    GET_TOTAL_COUNT: `${WORKFORCE_API_URL}/checklists/getTotalCount`,
    ADD_NEW: `${WORKFORCE_API_URL}/checklists/add`,
    UPDATE: `${WORKFORCE_API_URL}/checklists/update`,
    BULKUPDATE: `${WORKFORCE_API_URL}/checklists/bulkUpdate`,
  },
  PDFTEMPLATES: {
    GET_ALL: `${WORKFORCE_API_URL}/pdftemplates/getAll`,
    GET_BY_UIID: `${WORKFORCE_API_URL}/pdftemplates/get`,
    GET_TOTAL_COUNT: `${WORKFORCE_API_URL}/pdftemplates/getTotalCount`,
    ADD_NEW: `${WORKFORCE_API_URL}/pdftemplates/add`,
    UPDATE: `${WORKFORCE_API_URL}/pdftemplates/update`,
    BULKUPDATE: `${WORKFORCE_API_URL}/pdftemplates/bulkUpdate`,
  },
  CLIENTS: {
    GET_ALL: `${WORKFORCE_API_URL}/clients/getAll`,
    GET_BY_UIID: `${WORKFORCE_API_URL}/clients/get`,
    GET_TOTAL_COUNT: `${WORKFORCE_API_URL}/clients/getTotalCount`,
    ADD_NEW: `${WORKFORCE_API_URL}/clients/add`,
    UPDATE: `${WORKFORCE_API_URL}/clients/update`,
    ADD_CONTACT: `${WORKFORCE_API_URL}/contacts/add`,
    UPDATE_CONTACT: `${WORKFORCE_API_URL}/contacts/update`,
  },
  TIMESHEETS: {
    GET_ALL: `${WORKFORCE_API_URL}/timesheets/getAll`,
    GET_BY_UIID: `${WORKFORCE_API_URL}/timesheets/get`,
    GET_TOTAL_COUNT: `${WORKFORCE_API_URL}/timesheets/getTotalCount`,
    ADD_NEW: `${WORKFORCE_API_URL}/timesheets/add`,
    UPDATE: `${WORKFORCE_API_URL}/timesheets/update`,
  },
  PLACEMENTS: {
    GET_ALL: `${WORKFORCE_API_URL}/placements/getAll`,
    GET_BY_UIID: `${WORKFORCE_API_URL}/placements/get`,
    GET_TOTAL_COUNT: `${WORKFORCE_API_URL}/placements/getTotalCount`,
    ADD_NEW: `${WORKFORCE_API_URL}/placements/add`,
    UPDATE: `${WORKFORCE_API_URL}/placements/update`,
  },
  VENDORS: {
    GET_ALL: `${WORKFORCE_API_URL}/vendors/getAll`,
    GET_BY_UIID: `${WORKFORCE_API_URL}/vendors/get`,
    GET_TOTAL_COUNT: `${WORKFORCE_API_URL}/vendors/getTotalCount`,
    ADD_NEW: `${WORKFORCE_API_URL}/vendors/add`,
    UPDATE: `${WORKFORCE_API_URL}/vendors/update`,
    ADD_CONTACT: `${WORKFORCE_API_URL}/contacts/add`,
    UPDATE_CONTACT: `${WORKFORCE_API_URL}/contacts/update`,
  },
  WORK_AUTHS: {
    GET_ALL: `${WORKFORCE_API_URL}/workauths/getAll`,
    ADD_NEW: `${WORKFORCE_API_URL}/workauths/add`,
    UPDATE: `${WORKFORCE_API_URL}/workauths/update`,
  },
  // PLACEMENTS: {
  //   GET_ALL: `${WORKFORCE_API_URL}/placements/getAll`,
  //   GET_BY_UIID: `${WORKFORCE_API_URL}/placements/get`,
  //   ADD_NEW: `${WORKFORCE_API_URL}/placements/add`,
  //   UPDATE: `${WORKFORCE_API_URL}/placements/update`,
  // },
  IMMIGRATION: {
    GET_BY_UIID: `${WORKFORCE_API_URL}/immigrations/get`,
    ADD_NEW: `${WORKFORCE_API_URL}/immigrations/add`,
    UPDATE: `${WORKFORCE_API_URL}/immigrations/update`,
  },
  LCA: {
    GET_BY_UIID: `${WORKFORCE_API_URL}/lcas/get`,
    GET_ALL: `${WORKFORCE_API_URL}/lcas/getAll`,
    ADD_NEW: `${WORKFORCE_API_URL}/lcas/add`,
    UPDATE: `${WORKFORCE_API_URL}/lcas/update`,
  },
  H1B: {
    GET_BY_UIID: `${WORKFORCE_API_URL}/h1bs/get`,
    GET_ALL: `${WORKFORCE_API_URL}/h1bs/getAll`,
    ADD_NEW: `${WORKFORCE_API_URL}/h1bs/add`,
    UPDATE: `${WORKFORCE_API_URL}/h1bs/update`,
  },
  VISA: {
    GET_BY_UIID: `${WORKFORCE_API_URL}/visas/get`,
    GET_ALL: `${WORKFORCE_API_URL}/visas/getAll`,
    ADD_NEW: `${WORKFORCE_API_URL}/visas/add`,
    UPDATE: `${WORKFORCE_API_URL}/visas/update`,
  },

  JOBNADVS: {
    GET_BY_UIID: `${WORKFORCE_API_URL}/jobnadvs/get`,
    GET_ALL: `${WORKFORCE_API_URL}/jobnadvs/getAll`,
    ADD_NEW: `${WORKFORCE_API_URL}/jobnadvs/add`,
    UPDATE: `${WORKFORCE_API_URL}/jobnadvs/update`,
  },
  DOCUMENT: {
    GET_ALL: `${WORKFORCE_API_URL}/documents/getAll`,
    ADD_TAXFORM: `${WORKFORCE_API_URL}/emptaxforms/add`,
    GET_ALL_TAXFORM: `${WORKFORCE_API_URL}/emptaxforms/getAll`,
  },
  UNIVERSAL: {
    UPLOAD_FILE: `${WORKFORCE_API_URL}`,
    DOCUMENT_ADD: `${WORKFORCE_API_URL}/documents/add`,
    GET_S3_LINK: `${WORKFORCE_API_URL}/documents/getSignUrl?coll=Document`,
  },

  GET_TOTAL_COUNT: `${WORKFORCE_API_URL}`,
  GET_TOTAL_COUNT_ATS: `${ATS_API_URL}`,
  GET_TOTAL_COUNT_MASTER: `${MAIN_API_URL}`,
  GET_TOTAL_COUNT_BENCHSALES: `${BENCHSALES_API_URL}`,
  GET_TOTAL_COUNT_NONITMARKETING: `${NONITMARKETING_API_URL}`,

  ACCOUNT_PAYBLES: {
    GET_ALL: `${WORKFORCE_API_URL}/accountpayables/getAll`,
    GET_BY_UIID: `${WORKFORCE_API_URL}/accountpayables/get`,
    ADD_NEW: `${WORKFORCE_API_URL}/accountpayables/add`,
    UPDATE: `${WORKFORCE_API_URL}/accountpayables/update`,
  },
  INVOICES: {
    GET_ALL: `${WORKFORCE_API_URL}/invoices/getAll`,
    GET_BY_UIID: `${WORKFORCE_API_URL}/invoices/get`,
    ADD_NEW: `${WORKFORCE_API_URL}/invoices/add`,
    UPDATE: `${WORKFORCE_API_URL}/invoices/update`,
    BULKUPDATE: `${WORKFORCE_API_URL}/invoices/bulkUpdate`,
  },

  INCENTIVES: {
    GET_ALL: `${WORKFORCE_API_URL}/incentives/getAll`,
    GET_BY_UIID: `${WORKFORCE_API_URL}/incentives/get`,
    ADD_NEW: `${WORKFORCE_API_URL}/incentives/add`,
    UPDATE: `${WORKFORCE_API_URL}/incentives/update`,
    DELETE: `${WORKFORCE_API_URL}/incentives/delete`,
    GET_TOTAL_COUNT: `${WORKFORCE_API_URL}/incentives/getTotalCount`,
    GET_SHEET: `${WORKFORCE_API_URL}/incentives/sheet`,
    GET_SUMMARY: `${WORKFORCE_API_URL}/incentives/summary`,
  },
  INCENTIVE_SETTINGS: {
    GET_BY_KEY: `${WORKFORCE_API_URL}/incentivesettings/get`,
    ADD: `${WORKFORCE_API_URL}/incentivesettings/add`,
    UPDATE: `${WORKFORCE_API_URL}/incentivesettings/update`,
  },

  PAYROLL_SALARYY_PROFILE: {
    GET_ALL: `${WORKFORCE_API_URL}/salaryprofiles/getAll`,
    GET_BY_UIID: `${WORKFORCE_API_URL}/salaryprofiles/get`,
    ADD_NEW: `${WORKFORCE_API_URL}/salaryprofiles/add`,
    UPDATE: `${WORKFORCE_API_URL}/salaryprofiles/update`,
  },
  EMPLOYEE_PAY_CONFIGURATION: {
    GET_ALL: `${WORKFORCE_API_URL}/emppayconfigs/getAll`,
    GET_BY_UIID: `${WORKFORCE_API_URL}/emppayconfigs/get`,
    ADD_NEW: `${WORKFORCE_API_URL}/emppayconfigs/add`,
    UPDATE: `${WORKFORCE_API_URL}/emppayconfigs/update`,
  },
  PAYROLL: {
    GET_ALL: `${WORKFORCE_API_URL}/payrolls/getAll`,
    GET_BY_UIID: `${WORKFORCE_API_URL}/payrolls/get`,
    ADD_NEW: `${WORKFORCE_API_URL}/payrolls/add`,
    UPDATE: `${WORKFORCE_API_URL}/payrolls/update`,
    GET_TOTAL_COUNT: `${WORKFORCE_API_URL}/payrolls/getTotalCount`,
  },
  EMPLOYEE_DEDUCTIONS: {
    GET_ALL: `${WORKFORCE_API_URL}/empdeductions/getAll`,
    GET_BY_UIID: `${WORKFORCE_API_URL}/empdeductions/get`,
    ADD_NEW: `${WORKFORCE_API_URL}/empdeductions/add`,
    UPDATE: `${WORKFORCE_API_URL}/empdeductions/update`,
  },
  EMPLOYEE_OTHER_PAYMENTS: {
    GET_ALL: `${WORKFORCE_API_URL}/empotherpays/getAll`,
    GET_BY_UIID: `${WORKFORCE_API_URL}/empotherpays/get`,
    ADD_NEW: `${WORKFORCE_API_URL}/empotherpays/add`,
    UPDATE: `${WORKFORCE_API_URL}/empotherpays/update`,
  },
  RECONCILIATION: {
    GET_ALL: `${WORKFORCE_API_URL}/reconciliations/getAll`,
    GET_BY_UIID: `${WORKFORCE_API_URL}/reconciliations/get`,
    ADD_NEW: `${WORKFORCE_API_URL}/reconciliations/add`,
    UPDATE: `${WORKFORCE_API_URL}/reconciliations/parse-xlsx`,
    GET_TOTAL_COUNT: `${WORKFORCE_API_URL}/reconciliations/getTotalCount`,
  },
  EMPLOYEE_BONUS: {
    GET_ALL: `${WORKFORCE_API_URL}/empbonuspays/getAll`,
    GET_BY_UIID: `${WORKFORCE_API_URL}/empbonuspays/get`,
    ADD_NEW: `${WORKFORCE_API_URL}/empbonuspays/add`,
    UPDATE: `${WORKFORCE_API_URL}/empbonuspays/update`,
    GET_TOTAL_COUNT: `${WORKFORCE_API_URL}/empbonuspays/getTotalCount`,
  },
  EMPLOYEE_ADJUSTMENTS: {
    GET_ALL: `${WORKFORCE_API_URL}/empadjustments/getAll`,
    GET_TOTAL_COUNT: `${WORKFORCE_API_URL}/empadjustments/getTotalCount`,
  },
  MISC: {
    RUN_SERVER_TASKS: `${WORKFORCE_API_URL}/server-tasks`,
  },
  INCOMING_PLACEMENTS: {
    GET_ALL: `${WORKFORCE_API_URL}/incomingplacements/getAll`,
    GET_TOTAL_COUNT: `${WORKFORCE_API_URL}/incomingplacements/getTotalCount`,
    PUSH: `${WORKFORCE_API_URL}/placements/incoming`,
    APPROVE: `${WORKFORCE_API_URL}/placements/incoming`,
    UPDATE: `${WORKFORCE_API_URL}/incomingplacements/update`,
  },
  COMPANIES: {
    GET_ALL: `${ATS_API_URL}/companys/getAll`,
    GET_BY_UIID: `${ATS_API_URL}/companys/get`,
    ADD_NEW: `${ATS_API_URL}/companys/add`,
    DELETE: `${ATS_API_URL}/companys/delete`,
    UPDATE: `${ATS_API_URL}/companys/update`,
    MERGE: `${ATS_API_URL}/companys/mergeCompany`,
  },
  SYSTEMSTATS: {
    GET_ALL: `${ATS_API_URL}/systemstats/getAll`,
  },
  PROSPECTS: {
    GET_ALL: `${ATS_API_URL}/prospects/getAll`,
    GET: `${ATS_API_URL}/prospects/get`,
    BULK_UPDATE: `${ATS_API_URL}/prospects/bulkUpdate`,
    UPDATE: `${ATS_API_URL}/prospects/update`,
  },
  CITIES: {
    GET_ALL: `${MAIN_API_URL}/cities/getAll`,
    DELETE: `${MAIN_API_URL}/cities/delete`,
  },
  COUNTRIES: {
    GET_ALL: `${MAIN_API_URL}/countries/getAll`,
  },
  STATES: {
    ADD_NEW_LOCATION: `${MAIN_API_URL}/states/locations/add`,
    GET_ALL: `${MAIN_API_URL}/states/getAll`,
    DELETE: `${MAIN_API_URL}/states/delete`,
  },

  // STATES: {
  //   ADD_NEW_LOCATION: `${MAIN_API_URL}/states/locations/add`,
  //   GET_ALL: `${MAIN_API_URL}/states/getAll`,
  //   DELETE: `${MAIN_API_URL}/states/delete`,
  // },

  //here  first defined for ats , now we are hanging to benchsales api url
  JOBS: {
    GET_ALL: `${ATS_API_URL}/jobs/getAll`,
    GET: `${ATS_API_URL}/jobs/get`,
    ADD: `${ATS_API_URL}/jobs/add`,
    DELETE: `${ATS_API_URL}/jobs/delete`,
    UPDATE: `${ATS_API_URL}/jobs/update`,
  },
  TEAMLEAD: {
    GET_ALL: `${ATS_API_URL}/companys/getAll`,
  },
  JOBPOSTINGS: {
    ADD: `${ATS_API_URL}/jobpostings/add`,
    GET_ALL: `${ATS_API_URL}/jobpostings/getAll`,
    GET: `${ATS_API_URL}/jobpostings/get`,
    UPDATE: `${ATS_API_URL}/jobpostings/update`,
    //GET_QUESTIONS:`${ATS_API_URL}/jobpostquestions/getAll`
  },
  SETTINGS: {
    GET_ALL: `${ATS_API_URL}/settings/getAll`,
    ADD: `${ATS_API_URL}/settings/add`,
    UPDATE: `${ATS_API_URL}/settings/update`,
  },
  EMAILTEMPLATE: {
    GET_ALL: `${ATS_API_URL}/templates/getAll`,
    ADD: `${ATS_API_URL}/templates/add`,
    DELETE: `${ATS_API_URL}/templates/delete`,
    GET: `${ATS_API_URL}/templates/get`,
    UPDATE: `${ATS_API_URL}/templates/update`,
  },

  BDMJOBS: {
    GET_ALL: `${ATS_API_URL}/submissions/getAll`,
  },
  NOTES: {
    ADD: `${ATS_API_URL}/notes/add`,
    GET_ALL: `${ATS_API_URL}/notes/getAll`,
    DELETE: `${ATS_API_URL}/notes/delete`,
  },
  CLIPBOARDLOGS: {
    ADD: `${ATS_API_URL}/clipboardlogs/add`,
    GET_ALL: `${ATS_API_URL}/clipboardlogs/getAll`,
    GET: `${ATS_API_URL}/clipboardlogs/get`,
  },
  VISITHISTORYS: {
    ADD: `${ATS_API_URL}/visithistorys/add`,
    GET_ALL: `${ATS_API_URL}/visithistorys/getAll`,
    GET: `${ATS_API_URL}/visithistorys/get`,
  },
  INTEGRATIONS: {
    GET: `${ATS_API_URL}/integrations/get`,
    ADD: `${ATS_API_URL}/integrations/add`,
    UPDATE: `${ATS_API_URL}/integrations/update`,
    POST: `${ATS_API_URL}/integration/internal-db-resume-download`,
    GET_ALL: `${ATS_API_URL}/integrations/getAll`,
    DELETE: `${ATS_API_URL}/integrations/delete`,
  },
  INTEGRATION_ACCESS: {
    GET: `${ATS_API_URL}/integrationaccesss/get`,
    GET_ALL: `${ATS_API_URL}/integrationaccesss/getAll`,
    UPDATE: `${ATS_API_URL}/integrationaccesss/update`,
    ADD: `${ATS_API_URL}/integrationaccesss/add`,
  },
  RECRUITEMENT: {
    GET_ALL: `${ATS_API_URL}/candidates/getAll`,
  },

  ROLES: {
    GET_ALL: `${MAIN_API_URL}/roles/getAll`,
    ADD: `${MAIN_API_URL}/roles/add`,
    DELETE: `${MAIN_API_URL}/roles/delete`,
    UPDATE: `${MAIN_API_URL}/roles/update`,
    GET: `${MAIN_API_URL}/roles/get`,
  },

  SHUFFLE: {
    ADD: `${ATS_API_URL}/shuffles/add`,
    GET_ALL: `${ATS_API_URL}/shuffles/getAll`,
  },
  ORGANIZATIONS: {
    UPDATE: `${MAIN_API_URL}/organizations/update`,
    GET: `${MAIN_API_URL}/organizations/get`,
    UPLOAD: `${MAIN_API_URL}/organizations/upload`,
    GET_IMAGE_S3_LINK: `${MAIN_API_URL}/organizations/getSignUrl?coll=Organization`,
  },
  SUBMISSOINS: {
    UPDATE: `${ATS_API_URL}/submissions/update`,
    GET_ALL: `${ATS_API_URL}/submissions/getAll`,
    POST: `${ATS_API_URL}/submissions/add`,
    PUSH_TO_WORKFORCE: `${ATS_API_URL}/submissions/push-to-workforce`,
  },
  SEARCH: {
    MONSTER_SEARCH: `${ATS_API_URL}/integration/monster-search`,
    MONSTER_RESUME_IMPORT: `${ATS_API_URL}/integration/monster-resume-import`,
    MONSTER_RESUMES_IMPORT: `${ATS_API_URL}/integration/monster-resumes-import`,
    CAREER_BUILDER_SEARCH: `${ATS_API_URL}/integration/careerbuilder-search`,
    CAREER_BUILDER_RESUME_IMPORT: `${ATS_API_URL}/integration/careerbuilder-resume-import`,
    CAREER_BUILDER_RESUMES_IMPORT: `${ATS_API_URL}/integration/careerbuilder-resumes-import`,
    INTERNAL_DB: `${ATS_API_URL}/integration/internaldb-search`,
  },
  INSTANTLY: {
    GET_CAMPAIGN: `${ATS_API_URL}/integration/instantly-get-campaign`,
    GETALL_CAMPAIGN: `${ATS_API_URL}/integration/instanly-getall-campaign`,
    GET_BULK_ANALYST: `${ATS_API_URL}/integration/instantly-getbulk-analyst`,
    ADD_CAMPAIGN: `${ATS_API_URL}/integration/instantly-create-campaign`,
    PAUSE_CAMPAIGN: `${ATS_API_URL}/integration/instantly-pause-campaign`,
    START_CAMPAIGN: `${ATS_API_URL}/integration/instantly-start-campaign`,
    DELETE_CAMPAIGN: `${ATS_API_URL}/integration/instantly-delete-campaign`,
    UPDATE_CAMPAIGN: `${ATS_API_URL}/integration/instantly-update-campaign`,
    DUPLICATE_CAMPAIGN: `${ATS_API_URL}/integration/instantly-duplicate-campaign`,
  },
  JOB_BOARDS_HISTORY: {
    HISTORY: `${ATS_API_URL}/jobboardshistory`,
    ADD: `${ATS_API_URL}/jobboardshistory`, //for integrated search to add history
  },
  // signatures
  SIGNATURES: {
    GET: `${ATS_API_URL}/signatures/get`,
    UPDATE: `${ATS_API_URL}/signatures/update`,
    GET_ALL: `${ATS_API_URL}/signatures/getAll`,
    ADD: `${ATS_API_URL}/signatures/add`,
  },
  // prospectEmailLogs
  PROSPECTEMAILLOGS: {
    GET: `${ATS_API_URL}/prospectemaillogs/get`,
    UPDATE: `${ATS_API_URL}/prospectemaillogs/update`,
    GET_ALL: `${ATS_API_URL}/prospectemaillogs/getAll`,
    ADD: `${ATS_API_URL}/prospectemaillogs/add`,
  },

  CANDIDATES: {
    GET_ALL: `${ATS_API_URL}/candidates/getAll`,
    ADD: `${ATS_API_URL}/candidates/add`,
    GET: `${ATS_API_URL}/candidates/get`,
    UPDATE: `${ATS_API_URL}/candidates/update`,
    RESUME_URL: `${ATS_API_URL}/candidates/getSignUrl`,
    RESUME_PARSER: `${ATS_API_URL}/candidates/resume-parser`,
    BULK_RESUME_PARSER: `${ATS_API_URL}/candidates/bulk-resume-parser`,
  },

  JOB_BOARDS_CREDIT_HISTORY: {
    GET_ALL: `${ATS_API_URL}/jobboardcredithistorys/getAll`,
    ADD: `${ATS_API_URL}/jobboardcredithistorys/add`,
  },

  RESUME_MINING: {
    GET_ALL: `${ATS_API_URL}/resumeminings/getAll`,
    ADD: `${ATS_API_URL}/resumeminings/add`,
    DELETE: `${ATS_API_URL}/resumeminings/delete`,
    UPDATE: `${ATS_API_URL}/resumeminings/update`,
  },
  RESUME_MINING_HISTORY: {
    GET_ALL: `${ATS_API_URL}/resumemininghistorys/getAll`,
  },
  PUSH_DATA_TO_WORKFORCE: {
    GET: `${ATS_API_URL}/submissions/getAll`,
  },
  KULT_FETCH: {
    GET_ALL: `${ATS_API_URL}/kultfetches/getAll`,
  },
  HOTLIST: {
    GET_ALL: `${ATS_API_URL}/hotlists/getAll`,
  },
  TALENT_MATCH: {
    GET_ALL: `${ATS_API_URL}/talentmatches/getAll`,
    UPDATE: `${ATS_API_URL}/talentmatches/update`,
    BULK_UPDATE: `${ATS_API_URL}/talentmatches/bulkUpdate`,
  },
  ATS_UNIVERSAL: {
    UPLOAD_FILE: `${ATS_API_URL}`,
    DOCUMENT_ADD: `${ATS_API_URL}/documents/add`,
    GET_S3_LINK: `${ATS_API_URL}/documents/getSignUrl?coll=Document`,
  },
  BS_UNIVERSAL: {
    UPLOAD_FILE: `${BENCHSALES_API_URL}`,
    DOCUMENT_ADD: `${BENCHSALES_API_URL}/documents/add`,
    GET_S3_LINK: `${BENCHSALES_API_URL}/documents/getSignUrl?coll=Document`,
  },
  EMAIL: {
    POST: `${ATS_API_URL}/candidateemaillogs/add`,
    GET: `${ATS_API_URL}/candidateemaillogs/getTotalCount`,
    GET_ALL: `${ATS_API_URL}/candidateemaillogs/getAll`,
    GET_ALL_CAMPAIGNS: `${ATS_API_URL}/emailcampaigns/getAll`,
  },
  LOCAL_RESTRICTIONS: {
    ADD: `${ATS_API_URL}/locationrestrictions/add`,
    GET_ALL: `${ATS_API_URL}/locationrestrictions/getAll`,
    DELETE: `${ATS_API_URL}/locationrestrictions/delete`,
  },
  REPORTS: {
    GET_ALL: `${ATS_API_URL}/reports/getAll`,
  },
  FAVOURITE_REPORTS: {
    GET_ALL: `${ATS_API_URL}/favouritereports/getAll`,
    ADD: `${ATS_API_URL}/favouritereports/add`,
    DELETE: `${ATS_API_URL}/favouritereports/delete`,
  },
  AICALLS: {
    ADD: `${ATS_API_URL}/aicalls/add`,
    GET_ALL: `${ATS_API_URL}/aicalls/getAll`,
    GET_DETAILS: `${ATS_API_URL}/integration/kult-ai-call`,
    UPDATE: `${ATS_API_URL}/aicalls/update`,
  },
  EMAIL_LOGS: {
    ADD: `${ATS_API_URL}/emaillogs/add`,
  },
  CANDIDATE: {
    GET_ALL: `${BENCHSALES_API_URL}/candidates/getAll`,
    GET_BY_ID: `${BENCHSALES_API_URL}/candidates/getById`,
    ADD: `${BENCHSALES_API_URL}/candidates/add`,
    GET: `${BENCHSALES_API_URL}/candidates/get`,
    UPDATE: `${BENCHSALES_API_URL}/candidates/update`,
    GET_TOTAL_COUNT_CANDIDATE: `${BENCHSALES_API_URL}/candidates/getTotalCount`,
    UPLOAD: `${BENCHSALES_API_URL}/candidates/upload`,
    ANALYZE: `${BENCHSALES_API_URL}/candidates/analyze`,
    RESUME_PARSER: `${BENCHSALES_API_URL}/candidates/resume-parser`,
    GET_TOTAL_USER_COUNT: `${BENCHSALES_API_URL}/candidates/getTotalUsersCount`,
    GET_DOC: `${BENCHSALES_API_URL}/candidates/getSignUrl`,
    DELETE: `${BENCHSALES_API_URL}/candidates/delete`,
  },
  JOB: {
    GET_ALL: `${BENCHSALES_API_URL}/jobs/getAll`,
    GET_TOTAL_COUNT: `${BENCHSALES_API_URL}/jobs/getTotalUsersCount`,
    ADD: `${BENCHSALES_API_URL}/jobs/add`,
    UPDATE: `${BENCHSALES_API_URL}/jobs/update`,
  },
  CONTACTS: {
    ADD: `${BENCHSALES_API_URL}/contacts/add`,
    VERIFY: `${BENCHSALES_API_URL}/contacts/verify`,
    GET_ALL: `${BENCHSALES_API_URL}/contacts/getAll`,
    GET: `${BENCHSALES_API_URL}/contacts/get`,
    UPDATE: `${BENCHSALES_API_URL}/contacts/update`,
    DELETE: `${BENCHSALES_API_URL}/contacts/delete`,
  },
  SUBMISSION: {
    ADD: `${BENCHSALES_API_URL}/submissions/add`,
    GET_ALL: `${BENCHSALES_API_URL}/submissions/getAll`,
    GET_TOTAL_COUNT_SUBMISSION: `${BENCHSALES_API_URL}/submissions/getTotalCount`,
    // GET_TOTAL_USER_COUNT
    GET_TOTAL_USER_COUNT: `${BENCHSALES_API_URL}/submissions/getTotalUsersCount`,
  },
  USER_REFS: {
    ATS_USER_GET_ALL: `${ATS_API_URL}/userrefs/getAll`,
    ATS_USER_COUNT: `${ATS_API_URL}/userrefs/count`,
    ATS_USER_HIERARCHY: `${ATS_API_URL}/userrefs/getRepotingHierarchy`,
    WF_USER_GET_ALL: `${WORKFORCE_API_URL}/userrefs/getAll`,
    WF_USER_COUNT: `${WORKFORCE_API_URL}/userrefs/count`,
    ATS_GET_LEADS_MANAGERS: `${ATS_API_URL}/userrefs/getManager`,
    NONIT_USER_GET_ALL: `${ATS_API_URL}/userrefs/getNonItMarketingRecruiters`,
  },
  BUILD_VERSION: {
    ADD: `${ATS_API_URL}/buildversions/add`,
    GET_ALL: `${ATS_API_URL}/buildversions/getAll`,
  },
  ENGAGEMENT_STATUS: {
    ADD: `${ATS_API_URL}/engagementstatuss/add`,
    GET_ALL: `${ATS_API_URL}/engagementstatuss/getAll`,
  },
  INTERVIEW: {
    ADD: `${BENCHSALES_API_URL}/interviews/add`,
    GET_ALL: `${BENCHSALES_API_URL}/interviews/getAll`,
    GET_TOTAL_COUNT_INTERVIEWS: `${BENCHSALES_API_URL}/interviews/getTotalCount`,
    GET_TOTAL_MAIN_COUNT: `${BENCHSALES_API_URL}/interviews/getTotalMainCount`,
    GET_TOTAL_USER_COUNT: `${BENCHSALES_API_URL}/interviews/getTotalUsersCount`,
  },

  BS_REPORTS: {
    GET_ALL: `${BENCHSALES_API_URL}/reports/getAll`,
  },
  BS_TEMPLATES: {
    ADD: `${BENCHSALES_API_URL}/templates/add`,
    GET_ALL: `${BENCHSALES_API_URL}/templates/getAll`,
    DELETE: `${BENCHSALES_API_URL}/templates/delete`,
    UPDATE: `${BENCHSALES_API_URL}/templates/update`,
  },
  BS_CONTACTS: {
    POST: `${BENCHSALES_API_URL}/apollo/peoples`,
    POST_EMAIL: `${BENCHSALES_API_URL}/apollo/profiles?getEmail=true`,
    AUTH: `${BENCHSALES_API_URL}/apollo/auth`,
  },
  BS_AUTH: {
    UPDATE: `${BENCHSALES_API_URL}/authtokens/updateByEmail`,
  },
  BS_EMAILLOGS: {
    ADD: `${BENCHSALES_API_URL}/emaillogs/add`,
  },
  BS_GMAIL: {
    GMAIL_AUTH: `${BENCHSALES_API_URL}/gmail/auth`,
    GET_GMAIL: `${BENCHSALES_API_URL}/gmail/accounts`,
    MAIL_REPLY: `${BENCHSALES_API_URL}/reply/gmail`,
    DOWNLOAD_ATTACHMENT: `${BENCHSALES_API_URL}/download/gmail-attachment`,
  },
  BS_OUTLOOK: {
    OUTLOOK_AUTH: `${BENCHSALES_API_URL}/outlook/auth`,
    GET_OUTLOOK: `${BENCHSALES_API_URL}/outlook/accounts`,
    MAIL_REPLY: `${BENCHSALES_API_URL}/reply/outlook`,
    DOWNLOAD_ATTACHMENT: `${BENCHSALES_API_URL}/download/outlook-attachment`,
  },
  BS_MAIL_ACCOUNT: {
    ASSIGN_ACCESS: `${BENCHSALES_API_URL}/assign-access`,
    GET_MAIL_DATA_OUTLOOK: `${BENCHSALES_API_URL}/get-mails/outlook`,
    GET_MAIL_DATA_GMAIL: `${BENCHSALES_API_URL}/get-mails/gmail`,
  },
  EMAILACCOUNT: {
    GET_ALL: `${BENCHSALES_API_URL}/emailaccounts/getAll`,
    GET_TOTAL_COUNT: `${BENCHSALES_API_URL}/emailaccounts/getTotalUsersCount`,
    UPDATE: `${BENCHSALES_API_URL}/emailaccounts/updateAccessStatus`,
    DELETE: `${BENCHSALES_API_URL}/emailaccounts/delete`,
  },

  PLACEMENT: {
    ADD: `${BENCHSALES_API_URL}/placements/add`,
    GET_ALL: `${BENCHSALES_API_URL}/placements/getAll`,
    GET_TOTAL_COUNT_PLACEMENTS: `${BENCHSALES_API_URL}/placements/getTotalCount`,
    GET_TOTAL_USER_COUNT: `${BENCHSALES_API_URL}/placements/getTotalUsersCount`,

    PUSH_TO_WORKFORCE: `${BENCHSALES_API_URL}/placements/push-to-workforce`,
  },
  USEREF: {
    GET_ALL: `${BENCHSALES_API_URL}/userrefs/getAll`,
    GET_TOTAL_COUNT: `${BENCHSALES_API_URL}/userrefs/count`,
  },
  CANDIDATEVERSION: {
    GET_ALL: `${BENCHSALES_API_URL}/candidateversions/getAll`,
    DELETE: `${BENCHSALES_API_URL}/candidateversions/delete`,
  },
  OPTIMISERESUME: {
    GET_ALL: `${BENCHSALES_API_URL}/algorithm/kult`,
  },
  AIDRAFT: {
    GET_ALL: `${BENCHSALES_API_URL}/content/draft`,
  },

  BS_COMPANIES: {
    GET_ALL: `${BENCHSALES_API_URL}/companys/getAll`,
    ADD: `${BENCHSALES_API_URL}/companys/add`,
  },
  BS_INTEGRATION_ACCESS: {
    GET_ALL: `${BENCHSALES_API_URL}/integrationaccesses/getAll`,
    ADD: `${BENCHSALES_API_URL}/integrationaccess/add`,
  },
  LEAD_COMPANY: {
    GET_ALL: `${ATS_API_URL}/leadcompanys/getAll`,
    GET: `${ATS_API_URL}/leadcompanys/get`,
    AGREEMENT_URL: `${ATS_API_URL}/leadcompanys/getSignUrl`,
    ADD: `${ATS_API_URL}/leadcompanys/add`,
    UPDATE: `${ATS_API_URL}/leadcompanys/update`,
    DELETE: `${ATS_API_URL}/leadcompanys/delete`,
  },
  LEAD_JOB: {
    GET_ALL: `${ATS_API_URL}/leadjobs/getAll`,
    ADD: `${ATS_API_URL}/leadjobs/add`,
    UPDATE: `${ATS_API_URL}/leadjobs/update`,
  },
  LEAD_CONTACT: {
    GET_ALL: `${ATS_API_URL}/leadcontacts/getAll`,
    ADD: `${ATS_API_URL}/leadcontacts/add`,
    UPDATE: `${ATS_API_URL}/leadcontacts/update`,
  },
  BENCHSALES_HOTLIST: {
    GET_ALL: `${BENCHSALES_API_URL}/hotlists/getAll`,
    ADD: `${BENCHSALES_API_URL}/hotlists/add`,
    UPDATE: `${BENCHSALES_API_URL}/hotlists/update`,
    DELETE: `${BENCHSALES_API_URL}/hotlists/delete`,
  },
  INTEGRATION_BS: {
    GET_ALL: `${BENCHSALES_API_URL}/integrationbss/getAll`,
    ADD: `${BENCHSALES_API_URL}/integrationbss/add`,
    UPDATE: `${BENCHSALES_API_URL}/integrationbss/update`,
    DELETE: `${BENCHSALES_API_URL}/integrationbss/delete`,
  },
  INTEGRATION_ACCESS_BS: {
    GET: `${BENCHSALES_API_URL}/integrationaccesss/get`,
    GET_ALL: `${BENCHSALES_API_URL}/integrationaccesss/getAll`,
    UPDATE: `${BENCHSALES_API_URL}/integrationaccesss/update`,
    ADD: `${BENCHSALES_API_URL}/integrationaccesss/add`,
  },
  CREDIT_HISTORY_BS: {
    GET_ALL: `${BENCHSALES_API_URL}/credithistorys/getAll`,
    ADD: `${BENCHSALES_API_URL}/credithistorys/add`,
  },
  SETTINGS_BS: {
    GET_ALL: `${BENCHSALES_API_URL}/settings`,
  },
  CANDIDATE_PLATFORM_CREDENTIALS: {
    ADD: `${BENCHSALES_API_URL}/candidateplatformcredentials/add`,
    GET_ALL: `${BENCHSALES_API_URL}/candidateplatformcredentials/getAll`,
    UPDATE: `${BENCHSALES_API_URL}/candidateplatformcredentials/update`,
  },
  POSTCONFIG: {
    ADD: `${BENCHSALES_API_URL}/postconfigs/add`,
    GET_ALL: `${BENCHSALES_API_URL}/postconfigs/getAll`,
    DELETE: `${BENCHSALES_API_URL}/postconfigs/delete`,
  },
    LINKEDINPOST: {
    ADD: `${BENCHSALES_API_URL}/linkedinposts/add`,
    GET_ALL: `${BENCHSALES_API_URL}/linkedinposts/getAll`,
    DELETE: `${BENCHSALES_API_URL}/linkedinposts/delete`,
    GET_TOTAL_COUNT: `${BENCHSALES_API_URL}/linkedinposts/getTotalCount`,
  },

  TICKET: {
    ADD: `${ADMIN_API_URL}/tickets/add`,
  },
  PUBLIC: {
    GET_ORG_BASE_URL: `${MAIN_API_URL}/view/organizations`,
  },
  IP: {
    GET_ALL: `${MAIN_API_URL}/ipwhitelists/getAll`,
    ADD: `${MAIN_API_URL}/ipwhitelists/add`,
    UPDATE: `${MAIN_API_URL}/ipwhitelists/update`,
    DELETE: `${MAIN_API_URL}/ipwhitelists/delete`,
  },

  // NONITMARKETING_PATH=====================================
  CANDIDATE_NM: {
    GET_ALL: `${NONITMARKETING_API_URL}/candidates/getAll`,
    GET_BY_ID: `${NONITMARKETING_API_URL}/candidates/getById`,
    ADD: `${NONITMARKETING_API_URL}/candidates/add`,
    GET: `${NONITMARKETING_API_URL}/candidates/get`,
    UPDATE: `${NONITMARKETING_API_URL}/candidates/update`,
    GET_TOTAL_COUNT_CANDIDATE: `${NONITMARKETING_API_URL}/candidates/getTotalCount`,
    UPLOAD: `${NONITMARKETING_API_URL}/candidates/upload`,
    ANALYZE: `${NONITMARKETING_API_URL}/candidates/analyze`,
    RESUME_PARSER: `${NONITMARKETING_API_URL}/candidates/resume-parser`,
    GET_TOTAL_USER_COUNT: `${NONITMARKETING_API_URL}/candidates/getTotalUsersCount`,
    GET_DOC: `${NONITMARKETING_API_URL}/candidates/getSignUrl`,
    DELETE: `${NONITMARKETING_API_URL}/candidates/delete`,
  },
  Prospect_NM: {
    ADD: `${NONITMARKETING_API_URL}/prospects/add`,
    GET_ALL: `${NONITMARKETING_API_URL}/prospects/getAll`,
  },

  JOB_NM: {
    GET_ALL: `${NONITMARKETING_API_URL}/jobs/getAll`,
    GET_TOTAL_COUNT: `${NONITMARKETING_API_URL}/jobs/getTotalUsersCount`,
    ADD: `${NONITMARKETING_API_URL}/jobs/add`,
    UPDATE: `${NONITMARKETING_API_URL}/jobs/update`,
  },
  CONTACTS_NM: {
    ADD: `${NONITMARKETING_API_URL}/contacts/add`,
    VERIFY: `${NONITMARKETING_API_URL}/contacts/verify`,
    GET_ALL: `${NONITMARKETING_API_URL}/contacts/getAll`,
    GET: `${NONITMARKETING_API_URL}/contacts/get`,
    UPDATE: `${NONITMARKETING_API_URL}/contacts/update`,
    DELETE: `${NONITMARKETING_API_URL}/contacts/delete`,
  },
  SUBMISSION_NM: {
    ADD: `${NONITMARKETING_API_URL}/submissions/add`,
    GET_ALL: `${NONITMARKETING_API_URL}/submissions/getAll`,
    GET_TOTAL_COUNT_SUBMISSION: `${NONITMARKETING_API_URL}/submissions/getTotalCount`,
  },
  INTERVIEW_NM: {
    ADD: `${NONITMARKETING_API_URL}/interviews/add`,
    GET_ALL: `${NONITMARKETING_API_URL}/interviews/getAll`,
    GET_TOTAL_COUNT_INTERVIEWS: `${NONITMARKETING_API_URL}/interviews/getTotalCount`,
    GET_TOTAL_MAIN_COUNT: `${NONITMARKETING_API_URL}/interviews/getTotalMainCount`,
  },
  NM_REPORTS: {
    GET_ALL: `${NONITMARKETING_API_URL}/reports/getAll`,
  },
  NM_TEMPLATES: {
    ADD: `${NONITMARKETING_API_URL}/templates/add`,
    GET_ALL: `${NONITMARKETING_API_URL}/templates/getAll`,
    DELETE: `${NONITMARKETING_API_URL}/templates/delete`,
    UPDATE: `${NONITMARKETING_API_URL}/templates/update`,
  },
  NM_CONTACTS: {
    POST: `${NONITMARKETING_API_URL}/apollo/peoples`,
    POST_EMAIL: `${NONITMARKETING_API_URL}/apollo/profiles?getEmail=true`,
    AUTH: `${NONITMARKETING_API_URL}/apollo/auth`,
  },
  NM_AUTH: {
    UPDATE: `${NONITMARKETING_API_URL}/authtokens/updateByEmail`,
  },
  NM_EMAILLOGS: {
    ADD: `${NONITMARKETING_API_URL}/emaillogs/add`,
  },
  NM_GMAIL: {
    GMAIL_AUTH: `${NONITMARKETING_API_URL}/gmail/auth`,
    GET_GMAIL: `${NONITMARKETING_API_URL}/gmail/accounts`,
  },
  NM_OUTLOOK: {
    OUTLOOK_AUTH: `${NONITMARKETING_API_URL}/outlook/auth`,
    GET_OUTLOOK: `${NONITMARKETING_API_URL}/outlook/accounts`,
  },
  NM_MAIL_ACCOUNT: {
    ASSIGN_ACCESS: `${NONITMARKETING_API_URL}/assign-access`,
  },
  EMAILACCOUNT_NM: {
    GET_ALL: `${NONITMARKETING_API_URL}/emailaccounts/getAll`,
    GET_TOTAL_COUNT: `${NONITMARKETING_API_URL}/emailaccounts/getTotalUsersCount`,
    UPDATE: `${NONITMARKETING_API_URL}/emailaccounts/updateAccessStatus`,
    DELETE: `${NONITMARKETING_API_URL}/emailaccounts/delete`,
  },

  PLACEMENT_NM: {
    ADD: `${NONITMARKETING_API_URL}/placements/add`,
    GET_ALL: `${NONITMARKETING_API_URL}/placements/getAll`,
    GET_TOTAL_COUNT_PLACEMENTS: `${NONITMARKETING_API_URL}/placements/getTotalCount`,
  },
  USEREF_NM: {
    GET_ALL: `${NONITMARKETING_API_URL}/userrefs/getAll`,
    GET_TOTAL_COUNT: `${NONITMARKETING_API_URL}/userrefs/count`,
  },
  CANDIDATEVERSION_NM: {
    GET_ALL: `${NONITMARKETING_API_URL}/candidateversions/getAll`,
    DELETE: `${NONITMARKETING_API_URL}/candidateversions/delete`,
  },
  OPTIMISERESUME_NM: {
    GET_ALL: `${NONITMARKETING_API_URL}/algorithm/kult`,
  },
  AIDRAFT_NM: {
    GET_ALL: `${NONITMARKETING_API_URL}/content/draft`,
  },

  NM_COMPANIES: {
    GET_ALL: `${NONITMARKETING_API_URL}/companys/getAll`,
    ADD: `${NONITMARKETING_API_URL}/companys/add`,
  },
  NM_PROSPECTS: {
    ADD: `${NONITMARKETING_API_URL}/prospects/add`,
    GET_ALL: `${NONITMARKETING_API_URL}/prospects/getAll`,
    GET_ALL_COUNT: `${NONITMARKETING_API_URL}/prospects/getTotalCount`,
    MOVE_TO_CANDIDATE: `${NONITMARKETING_API_URL}/prospects/move-to-candidate`,
  },
  NM_CLIENTS: {
    ADD: `${NONITMARKETING_API_URL}/clients/add`,
    // GET_ALL: `${NONITMARKETING_API_URL}/clients/getAll`,
    // GET_TOTAL_COUNT: `${NONITMARKETING_API_URL}/clients/getTotalCount`,
    // UPDATE: `${NONITMARKETING_API_URL}/clients/update`,
    // DELETE: `${NONITMARKETING_API_URL}/clients/delete`,
  },
  NM_INTEGRATION_ACCESS: {
    GET_ALL: `${NONITMARKETING_API_URL}/integrationaccesses/getAll`,
    ADD: `${NONITMARKETING_API_URL}/integrationaccess/add`,
  },
  NM_HOTLIST: {
    GET_ALL: `${NONITMARKETING_API_URL}/hotlists/getAll`,
    ADD: `${NONITMARKETING_API_URL}/hotlists/add`,
    UPDATE: `${NONITMARKETING_API_URL}/hotlists/update`,
    DELETE: `${NONITMARKETING_API_URL}/hotlists/delete`,
  },
  INTEGRATION_NM: {
    GET_ALL: `${NONITMARKETING_API_URL}/integrationbss/getAll`,
    ADD: `${NONITMARKETING_API_URL}/integrationbss/add`,
    UPDATE: `${NONITMARKETING_API_URL}/integrationbss/update`,
    DELETE: `${NONITMARKETING_API_URL}/integrationbss/delete`,
  },
  INTEGRATION_ACCESS_NM: {
    GET: `${NONITMARKETING_API_URL}/integrationaccesss/get`,
    GET_ALL: `${NONITMARKETING_API_URL}/integrationaccesss/getAll`,
    UPDATE: `${NONITMARKETING_API_URL}/integrationaccesss/update`,
    ADD: `${NONITMARKETING_API_URL}/integrationaccesss/add`,
  },
  CREDIT_HISTORY_NM: {
    GET_ALL: `${NONITMARKETING_API_URL}/credithistorys/getAll`,
    ADD: `${NONITMARKETING_API_URL}/credithistorys/add`,
  },
  SETTINGS_NM: {
    GET_ALL: `${NONITMARKETING_API_URL}/settings`,
  },
  CANDIDATE_PLATFORM_CREDENTIALS_NM: {
    ADD: `${NONITMARKETING_API_URL}/candidateplatformcredentials/add`,
    GET_ALL: `${NONITMARKETING_API_URL}/candidateplatformcredentials/getAll`,
    UPDATE: `${NONITMARKETING_API_URL}/candidateplatformcredentials/update`,
  },
};
export const ALLOWED_ORIGINS = import.meta.env.VITE_ALLOWED_ORIGINS?.split(",");
